const $2a9f999bc54a0719$export$4051a07651545597 = [
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.REYNI S.L.",
        "DOMICILIO": "CC-550 KM.4,1  (PADRON RIBEIRA)",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15981,
        "lat": 42.714921,
        "long": -8.695786
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S.G.- GODELLETA",
        "DOMICILIO": "CTRA.VV-3061 KM.11,7",
        "PROVINCIA": "VALENCIA",
        "CP": 46388,
        "lat": 39.42502,
        "long": -0.68072
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL PILAR",
        "DOMICILIO": "JUAN CARLOS I S\/N",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15706,
        "lat": 42.876064,
        "long": -8.548518
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BURRIANA",
        "DOMICILIO": "CC-236 KM.0,300",
        "PROVINCIA": "CASTELLON",
        "CP": 12530,
        "lat": 39.89416,
        "long": -0.08011
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MOAL GASOLINERAS,SL",
        "DOMICILIO": "C.R. DEL MAR, KM-0,5",
        "PROVINCIA": "CASTELLON",
        "CP": 12592,
        "lat": 39.77858,
        "long": -0.18072
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.S.PRUDENCIO-MINATEDA",
        "DOMICILIO": "A-30, SALIDA 69",
        "PROVINCIA": "ALBACETE",
        "CP": 2499,
        "lat": 38.4642,
        "long": -1.59672
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. RODA I",
        "DOMICILIO": "AUTOVIA A-31 KM. 50,50",
        "PROVINCIA": "ALBACETE",
        "CP": 2630,
        "lat": 39.144115,
        "long": -2.051183
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S LA RODA 2",
        "DOMICILIO": "AUTOVIA A-31 KM. 34,60",
        "PROVINCIA": "ALBACETE",
        "CP": 2630,
        "lat": 39.225045,
        "long": -2.186065
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SANFUL SERVICIOS SL",
        "DOMICILIO": "CTRA CN-859 KM 4,5",
        "PROVINCIA": "ALICANTE",
        "CP": 3177,
        "lat": 38.11333,
        "long": -0.72638
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. JUNCARET, S.L.",
        "DOMICILIO": "VIAL CONEXION N-332 Y A-7",
        "PROVINCIA": "ALICANTE",
        "CP": 3016,
        "lat": 38.37,
        "long": -0.44666
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL ESPARTAL - ALC",
        "DOMICILIO": "CTRA 330, KM-409,1 POL. EL ESPARTAL",
        "PROVINCIA": "ALICANTE",
        "CP": 3007,
        "lat": 38.34527,
        "long": -0.5203
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EZCARAY",
        "DOMICILIO": "EZCARAY S\/N",
        "PROVINCIA": "LA RIOJA",
        "CP": 26280,
        "lat": 42.332884,
        "long": -3.012807
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ROSA DE LOS VIENTOS",
        "DOMICILIO": "C/ROSA DE LOS VIENTOS ESQ C\xba ELCHE VIEJO",
        "PROVINCIA": "ALICANTE",
        "CP": 3007,
        "lat": 38.33778,
        "long": -0.52314
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LAS MARINAS-ALTEA",
        "DOMICILIO": "CARRER LA MAR 137",
        "PROVINCIA": "ALICANTE",
        "CP": 3590,
        "lat": 38.59322,
        "long": -0.05492
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES LAS MARINAS-S.VICENTE",
        "DOMICILIO": "CTRA. S. VICENTE-AGOST KM. 1",
        "PROVINCIA": "ALICANTE",
        "CP": 3690,
        "lat": 38.40125,
        "long": -0.53533
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP CAUDETE",
        "DOMICILIO": "AVDA. DE VALENCIA, N\xba 46",
        "PROVINCIA": "ALBACETE",
        "CP": 2660,
        "lat": 38.70988,
        "long": -0.98486
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LAS MARINAS-SAN GABRIEL",
        "DOMICILIO": "AVDA. RAMON GOMEZ SEMPERE, 4",
        "PROVINCIA": "ALICANTE",
        "CP": 3008,
        "lat": 38.33058,
        "long": -0.5135
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LAS MARINAS-CAMPELLO",
        "DOMICILIO": "C/ SAN BARTOLOME, N\xba3",
        "PROVINCIA": "ALICANTE",
        "CP": 3560,
        "lat": 38.422932,
        "long": -0.397487
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S. ALLARIZ, S.L.",
        "DOMICILIO": "CN-525 KM.216,400",
        "PROVINCIA": "ORENSE",
        "CP": 32660,
        "lat": 42.193672,
        "long": -7.794821
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ALOYAS, S.L.",
        "DOMICILIO": "AGUSTIN BRAVO, S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33120,
        "lat": 43.487937,
        "long": -6.110831
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.DE LA VEGA I",
        "DOMICILIO": "CN-634 KM.310",
        "PROVINCIA": "ASTURIAS",
        "CP": 33594,
        "lat": 43.431695,
        "long": -4.857126
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL EMPALME",
        "DOMICILIO": "BARRIO SAN MARTIN S\/N",
        "PROVINCIA": "CANTABRIA",
        "CP": 39011,
        "lat": 43.447644,
        "long": -3.854259
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LOS NUNEZ SL",
        "DOMICILIO": "CARRETERA PORTUGAL KM. 0",
        "PROVINCIA": "BADAJOZ",
        "CP": 6134,
        "lat": 38.239634,
        "long": -7.121738
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ANTUNEZ",
        "DOMICILIO": "C\/ ELECTRICIDAD, S\/N",
        "PROVINCIA": "BADAJOZ",
        "CP": 6200,
        "lat": 38.692313,
        "long": -6.40883
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SILVEROIL",
        "DOMICILIO": "BARRIO DE LAS MAZAS, 37",
        "PROVINCIA": "ASTURIAS",
        "CP": 33191,
        "lat": 43.359929,
        "long": -5.89887
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. VIRGEN DE BARBA\xd1O",
        "DOMICILIO": "CTRA. LOBON-LA ROCA P.K. 5,300",
        "PROVINCIA": "BADAJOZ",
        "CP": 6480,
        "lat": 38.902383,
        "long": -6.607944
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "US DISBE CALA RAJADA",
        "DOMICILIO": "JOAN CARLES I, 68",
        "PROVINCIA": "BALEARES",
        "CP": 7590,
        "lat": 39.703446,
        "long": 3.444712
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BS POLLENSA",
        "DOMICILIO": "C\/ FUSTER, 35",
        "PROVINCIA": "BALEARES",
        "CP": 7460,
        "lat": 39.887449,
        "long": 3.030611
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S ESTADIO BALEAR",
        "DOMICILIO": "GEORGE SAND, 4",
        "PROVINCIA": "BALEARES",
        "CP": 7007,
        "lat": 39.5739,
        "long": 2.68007
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SON CASTELLO",
        "DOMICILIO": "AVDA. GRAN VIA ASIMA POL. SON CASTELLO",
        "PROVINCIA": "BALEARES",
        "CP": 7009,
        "lat": 39.605798,
        "long": 2.669534
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VISTA ALEGRE BURELA, S.L",
        "DOMICILIO": "C/ARCADIO PARDI\xd1AS S/N",
        "PROVINCIA": "LUGO",
        "CP": 27880,
        "lat": 43.651479,
        "long": -7.353668
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. FUENTE LA HIGUERA",
        "DOMICILIO": "ES AUTOVIA A-35 KM. 11",
        "PROVINCIA": "VALENCIA",
        "CP": 46630,
        "lat": 38.82713,
        "long": -0.89066
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MKT OIL PALAFOLLS",
        "DOMICILIO": "CTRA. B-682 KM 2.432",
        "PROVINCIA": "BARCELONA",
        "CP": 8389,
        "lat": 41.6677,
        "long": 2.75547
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MULTISERVICIO EIMIL",
        "DOMICILIO": "C\/ CIUDAD DE LUGO, 68-70",
        "PROVINCIA": "LUGO",
        "CP": 27800,
        "lat": 43.288843,
        "long": -7.67926
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E S LOS BALBASES",
        "DOMICILIO": "AUTOVIA A-62 KM.40",
        "PROVINCIA": "BURGOS",
        "CP": 9229,
        "lat": 42.177349,
        "long": -4.059727
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. RIO SALOR",
        "DOMICILIO": "CTRA N523 KM 9,5",
        "PROVINCIA": "CACERES",
        "CP": 10105,
        "lat": 39.387826,
        "long": -6.435597
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PALO AREAS DE SERVICIO",
        "DOMICILIO": "P.I CERRO DE SAN FRANCISCO PAR 18",
        "PROVINCIA": "CACERES",
        "CP": 10500,
        "lat": 39.413029,
        "long": -7.233147
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MARTOP, S.L.",
        "DOMICILIO": "CEX-118 KM.60,150",
        "PROVINCIA": "CACERES",
        "CP": 10335,
        "lat": 39.85943,
        "long": -5.47062
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. OTISA MARVIC, S.L.",
        "DOMICILIO": "AVDA.CONSTITUCI\xd3N S/N",
        "PROVINCIA": "BADAJOZ",
        "CP": 6640,
        "lat": 39.02979,
        "long": -5.23396
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SUSANA Y DAVID SL",
        "DOMICILIO": "CARRETERA 342 JEREZ-CARTAGENA PK 48 IZQ.",
        "PROVINCIA": "CADIZ",
        "CP": 11649,
        "lat": 36.824532,
        "long": -5.741771
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL COMENDADOR, S.L.",
        "DOMICILIO": "C/ LAS CRUCES N\xba4",
        "PROVINCIA": "TOLEDO",
        "CP": 45890,
        "lat": 39.81142,
        "long": -3.10788
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PELAGATOS CHICLANA",
        "DOMICILIO": "PI PELAGATOS C\/ CRUZ DE LA CALZADA, S\/N",
        "PROVINCIA": "CADIZ",
        "CP": 11580,
        "lat": 36.407884,
        "long": -6.130641
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PRADO DE LA FERIA",
        "DOMICILIO": "PRADO DE LA FERIA C\/AUSTRIA, 1",
        "PROVINCIA": "CADIZ",
        "CP": 11170,
        "lat": 36.47061,
        "long": -5.943915
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SANSA, S.L.",
        "DOMICILIO": "CC-642 KM.8,4",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15560,
        "lat": 43.527183,
        "long": -8.084977
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MERA, S.L.",
        "DOMICILIO": "CC-642 KM.33,9",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15338,
        "lat": 43.678084,
        "long": -7.846717
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.LA JUNQUERA",
        "DOMICILIO": "CN-420 KM.143,700",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13450,
        "lat": 38.671181,
        "long": -4.262555
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL CARBALLAL, S.L.",
        "DOMICILIO": "AVDA.DEL AEROPUERTO-CARBALLAL KM.6,3",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36318,
        "lat": 42.23345,
        "long": -8.64369
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MALOCA EL BOSQUE",
        "DOMICILIO": "CC-344, MARGEN DERECHO",
        "PROVINCIA": "CADIZ",
        "CP": 11670,
        "lat": 36.75825,
        "long": -5.51269
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VEJER",
        "DOMICILIO": "CN-340, KM-30,277",
        "PROVINCIA": "CADIZ",
        "CP": 11150,
        "lat": 36.2534,
        "long": -6.02541
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA ARENOSA",
        "DOMICILIO": "CTRA.JEREZ-CORTES,KM-32,7",
        "PROVINCIA": "CADIZ",
        "CP": 11580,
        "lat": 36.61269,
        "long": -5.80993
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. RUXIDOIRA, S.L.",
        "DOMICILIO": "AVDA. GENERAL FRANCO, S\/N",
        "PROVINCIA": "LUGO",
        "CP": 27611,
        "lat": 42.761895,
        "long": -7.56351
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SERVICIOS PUENTE LINARES",
        "DOMICILIO": "CN-640 KM.201,7",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36687,
        "lat": 42.698211,
        "long": -8.459129
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.CUATROCALZADAS, S.L.",
        "DOMICILIO": "CN-630 KM.359,180",
        "PROVINCIA": "SALAMANCA",
        "CP": 37893,
        "lat": 40.80861,
        "long": -5.63118
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "N.S.HIJOS DE TERESA FDEZ",
        "DOMICILIO": "CN-540 KM.28,38",
        "PROVINCIA": "ORENSE",
        "CP": 32813,
        "lat": 42.12731,
        "long": -7.95104
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PETROJAMER",
        "DOMICILIO": "AVD. PORTUGAL, 46",
        "PROVINCIA": "LEON",
        "CP": 24750,
        "lat": 42.29356,
        "long": -5.91201
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA ISLA",
        "DOMICILIO": "CTRA.SOTO DEL BARCO A CORNELLANA KM.4,14",
        "PROVINCIA": "ASTURIAS",
        "CP": 33127,
        "lat": 43.499391,
        "long": -6.077693
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. DARIANA",
        "DOMICILIO": "CTRA. N-420 KM 292,700",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13610,
        "lat": 39.401018,
        "long": -3.149095
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S SOCUELLAMOS",
        "DOMICILIO": "CRTA. N 310 KM. 104,70",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13630,
        "lat": 39.164184,
        "long": -2.884799
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. VALTA ENERXIA, S.L.",
        "DOMICILIO": "LG. SIONLLA DE ARRIBA S\/N",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15884,
        "lat": 42.922838,
        "long": -8.486987
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LAG OLEIROS",
        "DOMICILIO": "AVDA DAS MARI\xd1AS CTRA. NIV P.K. 589,60",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15172,
        "lat": 43.328846,
        "long": -8.366282
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LAG SIONLLA GALP",
        "DOMICILIO": "RUA PAIS VASCO 6",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15707,
        "lat": 42.903457,
        "long": -8.501467
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "L.A.G. MARTELO",
        "DOMICILIO": "CTRA. AC-543 PK 23",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15911,
        "lat": 42.812584,
        "long": -8.77629
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.TRES CAMINOS, S.L.",
        "DOMICILIO": "MAYOR, 57",
        "PROVINCIA": "VALENCIA",
        "CP": 46980,
        "lat": 39.50378,
        "long": -0.44407
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MARGE, S.A.",
        "DOMICILIO": "AV SANT JOSEP DE SA TALAIA, 42",
        "PROVINCIA": "BALEARES",
        "CP": 7800,
        "lat": 38.90497,
        "long": 1.41293
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LOS ANGELES",
        "DOMICILIO": "CTRA. SANTIAGO-NOIA KM 12",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15280,
        "lat": 42.853782,
        "long": -8.671169
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES MKT OIL BLANES POLIGO",
        "DOMICILIO": "AVDA. EUROPA, 47",
        "PROVINCIA": "GIRONA",
        "CP": 17300,
        "lat": 41.675869,
        "long": 2.71459
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES MKT OIL BLANES HOSPIT",
        "DOMICILIO": "CTRA. GI-682 KM 7",
        "PROVINCIA": "GIRONA",
        "CP": 17300,
        "lat": 41.688544,
        "long": 2.800832
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MKT OIL LLORET",
        "DOMICILIO": "CTRA. GI-682 KM 10",
        "PROVINCIA": "GIRONA",
        "CP": 17310,
        "lat": 41.69806,
        "long": 2.82724
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LL0RET ALEGRIAS",
        "DOMICILIO": "AVDA.ALEGRIES, 1",
        "PROVINCIA": "GIRONA",
        "CP": 17310,
        "lat": 41.71696,
        "long": 2.83
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP FIGUERES",
        "DOMICILIO": "RONDA SUR S\/N",
        "PROVINCIA": "GIRONA",
        "CP": 17600,
        "lat": 42.26124,
        "long": 2.975463
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL MANO",
        "DOMICILIO": "CARRETERA BENAMAUREL KM.2,2",
        "PROVINCIA": "GRANADA",
        "CP": 18816,
        "lat": 37.50868,
        "long": -2.76589
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S.EL TORREON - SEVILLA",
        "DOMICILIO": "AUTOVIA A-92 KM.239",
        "PROVINCIA": "GRANADA",
        "CP": 18220,
        "lat": 37.23153,
        "long": -3.66851
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AREA DE SERVICIO CENES",
        "DOMICILIO": "CAMINO DEL ASADERO S\/N",
        "PROVINCIA": "GRANADA",
        "CP": 18190,
        "lat": 37.15703,
        "long": -3.54638
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CRUZ ALTERA",
        "DOMICILIO": "CTRA. ILLORA KM 2",
        "PROVINCIA": "GRANADA",
        "CP": 18270,
        "lat": 37.32486,
        "long": -3.98792
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. INVERSIONES LAROLES",
        "DOMICILIO": "CTRA. PUERTO KM 9,200",
        "PROVINCIA": "GRANADA",
        "CP": 18194,
        "lat": 37.0084,
        "long": -3.01113
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP NEVADA EL TORREON",
        "DOMICILIO": "CARRETERA GRANADA ARMILLA KM 134.25",
        "PROVINCIA": "GRANADA",
        "CP": 18100,
        "lat": 37.15411,
        "long": -3.61195
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "OILSAN ENERGY, S.L.U.",
        "DOMICILIO": "AVENIDA DEL SOL ESQ. AVDA. DE FRANCIA",
        "PROVINCIA": "GUADALAJARA",
        "CP": 19005,
        "lat": 40.64383,
        "long": -3.1419
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. OILSAN ENERGY",
        "DOMICILIO": "CARRETERA GUADALAJARA-UCEDA, KM 2,800",
        "PROVINCIA": "GUADALAJARA",
        "CP": 19180,
        "lat": 40.6671,
        "long": -3.2
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "OILSAN ENERGY",
        "DOMICILIO": "CTRA NACIONAL II KM 47,580",
        "PROVINCIA": "GUADALAJARA",
        "CP": 19208,
        "lat": 40.594774,
        "long": -3.225435
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL BANDERIN",
        "DOMICILIO": "AVDA. CAYETANO FEU S\/N",
        "PROVINCIA": "HUELVA",
        "CP": 21400,
        "lat": 37.214154,
        "long": -7.401234
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. THARSIS S.L.",
        "DOMICILIO": "PUEBLO NUEVO, SN",
        "PROVINCIA": "HUELVA",
        "CP": 21530,
        "lat": 37.591966,
        "long": -7.12019
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL GRANAO S.L.",
        "DOMICILIO": "CTRA. EL GRANADO- VV CASTILLEBOS KM 0",
        "PROVINCIA": "HUELVA",
        "CP": 21594,
        "lat": 37.52212,
        "long": -7.41249
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. NAZAR DESPENAPERROS",
        "DOMICILIO": "AUTOVIA MADRID-CADIZ KM 259",
        "PROVINCIA": "JAEN",
        "CP": 23213,
        "lat": 38.3293,
        "long": -3.54497
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MIRADOR DE CAZORLA",
        "DOMICILIO": "CTRA. A-319 KM 11,5",
        "PROVINCIA": "JAEN",
        "CP": 23470,
        "lat": 37.92077,
        "long": -3.01926
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CF & RS E.S. SLU",
        "DOMICILIO": "CTRA.VILLACARRILLO-HUERCAL OVERA KM.63,1",
        "PROVINCIA": "JAEN",
        "CP": 23485,
        "lat": 37.71186,
        "long": -2.95402
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.MIRABUENO-GALP",
        "DOMICILIO": "AVDA.DE JAEN, S\/N",
        "PROVINCIA": "JAEN",
        "CP": 23650,
        "lat": 37.76266,
        "long": -3.93536
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. BADECAR PINAR",
        "DOMICILIO": "CTRA. LE 125",
        "PROVINCIA": "LEON",
        "CP": 24734,
        "lat": 42.198174,
        "long": -6.109111
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-VALDERAS",
        "DOMICILIO": "CR BENDUENTE, 1",
        "PROVINCIA": "LEON",
        "CP": 24220,
        "lat": 42.076452,
        "long": -5.44429
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES VILLADANGOS",
        "DOMICILIO": "CN120 KM 322,300 (DIRECCION ASTORGA)",
        "PROVINCIA": "LEON",
        "CP": 24392,
        "lat": 42.524969,
        "long": -5.756707
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MANSILLA",
        "DOMICILIO": "CTRA. N601 KM 312.400",
        "PROVINCIA": "LEON",
        "CP": 24217,
        "lat": 42.50146,
        "long": -5.4162
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E .S. VILLAQUILAMBRE",
        "DOMICILIO": "CTRA. LE-311, KM. 3,500",
        "PROVINCIA": "LEON",
        "CP": 24193,
        "lat": 42.63323,
        "long": -5.55976
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LEON URBANA",
        "DOMICILIO": "AVDA. ANTIBIOTICOS S\/N",
        "PROVINCIA": "LEON",
        "CP": 24309,
        "lat": 42.572516,
        "long": -5.583104
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GARRIGUES MD",
        "DOMICILIO": "AP-2 PK 163,700",
        "PROVINCIA": "LLEIDA",
        "CP": 25400,
        "lat": 41.487616,
        "long": 0.865613
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GARRIGUES MI",
        "DOMICILIO": "AP-2 PK 163,700",
        "PROVINCIA": "LLEIDA",
        "CP": 25400,
        "lat": 41.489051,
        "long": 0.865597
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ADELFAS OIL",
        "DOMICILIO": "POLIGONO MORETA P4",
        "PROVINCIA": "LA RIOJA",
        "CP": 26570,
        "lat": 42.234054,
        "long": -2.063439
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ADELFAS NAJERA",
        "DOMICILIO": "SAN FERNANDO 120",
        "PROVINCIA": "LA RIOJA",
        "CP": 26300,
        "lat": 42.416294,
        "long": -2.71851
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ADELFAS OIL-TEJERIAS",
        "DOMICILIO": "SAN LAZARO-TEJERIAS S\/N",
        "PROVINCIA": "LA RIOJA",
        "CP": 26500,
        "lat": 42.28914,
        "long": -1.94316
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SERV. G.T.V. REYNI, S.L.",
        "DOMICILIO": "POLIGONO INDUSTRIAL LA PICARA\xd1A S/N",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15980,
        "lat": 42.804784,
        "long": -8.636134
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ABREA CUQUEJO, S.L.",
        "DOMICILIO": "ENLACE AUTOVIA A52, SALIDA 173",
        "PROVINCIA": "ORENSE",
        "CP": 32689,
        "lat": 41.98361,
        "long": -7.54155
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LAPIDO, S.L.",
        "DOMICILIO": "CC-543 KM.7,51",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15864,
        "lat": 42.864319,
        "long": -8.629028
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S. A BARCA, S.L.",
        "DOMICILIO": "AVDA.DOMINGO FONTAN, N\xba2 LOCAL-44",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36005,
        "lat": 42.434272,
        "long": -8.653545
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. BEADE, S.L.",
        "DOMICILIO": "CTRA.OR-210,KM-3,8(CARBALLINO-RIBADAVIA)",
        "PROVINCIA": "ORENSE",
        "CP": 32431,
        "lat": 42.31776,
        "long": -8.12353
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "TAMALLANCOS, S.L.",
        "DOMICILIO": "CTRA. N-525, P.K. 250,7",
        "PROVINCIA": "ORENSE",
        "CP": 32102,
        "lat": 42.423067,
        "long": -7.887956
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PORCEYO S.L.",
        "DOMICILIO": "AUTOVIA AS2, N\xba4000 SALIDA 20",
        "PROVINCIA": "ASTURIAS",
        "CP": 33392,
        "lat": 43.495349,
        "long": -5.717121
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PETROSCOS",
        "DOMICILIO": "CTRA.PESOZ-ALTO DE LA GARGANTA KM.20,74",
        "PROVINCIA": "ASTURIAS",
        "CP": 33777,
        "lat": 43.31041,
        "long": -6.98625
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA FRESNEDA",
        "DOMICILIO": "LAS CABANAS, S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33420,
        "lat": 43.41546,
        "long": -5.79721
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP A.S FRONTERA DE CAY",
        "DOMICILIO": "CN-V KM.405,715",
        "PROVINCIA": "BADAJOZ",
        "CP": 6006,
        "lat": 38.89066,
        "long": -7.01419
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CENTRO INTEGR.SERVICIOS",
        "DOMICILIO": "CTRA.FUENLABRADA-PINTO KM.16,300",
        "PROVINCIA": "MADRID",
        "CP": 28941,
        "lat": 40.274583,
        "long": -3.760752
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VILLALVILLA ALVASAN",
        "DOMICILIO": "JAIME FERRAN, 31",
        "PROVINCIA": "MADRID",
        "CP": 28810,
        "lat": 40.44777,
        "long": -3.32561
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. COSLADA II",
        "DOMICILIO": "C\/INGENIERO FERNANDEZ CASADO,14",
        "PROVINCIA": "MADRID",
        "CP": 28822,
        "lat": 40.430526,
        "long": -3.533832
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MOVILOIL",
        "DOMICILIO": "C/ E, 7 POLIGONO N\xba 1",
        "PROVINCIA": "MADRID",
        "CP": 28938,
        "lat": 40.309022,
        "long": -3.873811
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA CANTUE\xd1A, S.L.",
        "DOMICILIO": "A-42 KM 17,400",
        "PROVINCIA": "MADRID",
        "CP": 28945,
        "lat": 40.265831,
        "long": -3.758569
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. NAVAS DEL REY S.L.",
        "DOMICILIO": "M-501, KM 401,500",
        "PROVINCIA": "MADRID",
        "CP": 28945,
        "lat": 40.383159,
        "long": -4.240808
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. TORREJON DE VELASCO",
        "DOMICILIO": "CTRA. M-404 KM. 28",
        "PROVINCIA": "MADRID",
        "CP": 28990,
        "lat": 40.188193,
        "long": -3.76433
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP GUADAHORCE",
        "DOMICILIO": "C\/ HERMAN HESSE ESQ. GERALD BRENAN",
        "PROVINCIA": "MALAGA",
        "CP": 29004,
        "lat": 36.687987,
        "long": -4.471055
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP ESTEPONA CENTRO",
        "DOMICILIO": "C/ DOCTOR CRISTOBAL RUIZ MENDEZ, N\xba75",
        "PROVINCIA": "MALAGA",
        "CP": 29680,
        "lat": 36.423239,
        "long": -5.15566
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.EL PASO GALP LA CALA",
        "DOMICILIO": "FINCA EL PASO",
        "PROVINCIA": "MALAGA",
        "CP": 29649,
        "lat": 36.509484,
        "long": -4.687376
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CARAVACA",
        "DOMICILIO": "CTRA.GRANADA, S\/N: PARAJE SANTA INES",
        "PROVINCIA": "MURCIA",
        "CP": 30400,
        "lat": 38.08947,
        "long": -1.86794
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.T.LA ALBERCA SERVICIOS",
        "DOMICILIO": "CTRA EL PALMAR N\xba1",
        "PROVINCIA": "MURCIA",
        "CP": 30150,
        "lat": 37.94327,
        "long": -1.15133
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PTE. TOCINOS GALP",
        "DOMICILIO": "C/ MAYOR, N\xba12",
        "PROVINCIA": "MURCIA",
        "CP": 30006,
        "lat": 37.99078,
        "long": -1.10858
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ANSOAIN ARTICA",
        "DOMICILIO": "CTRA. ARTICA ESQUINA C\/AIZOAIN",
        "PROVINCIA": "NAVARRA",
        "CP": 31013,
        "lat": 42.83194,
        "long": -1.65104
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. BERRIOPLANO",
        "DOMICILIO": "CALLE MARINA BICARRET 3",
        "PROVINCIA": "NAVARRA",
        "CP": 31195,
        "lat": 42.8332,
        "long": -1.664532
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. NITO, S.L.",
        "DOMICILIO": "CN-532 KM-13,1",
        "PROVINCIA": "ORENSE",
        "CP": 32699,
        "lat": 41.825222,
        "long": -7.425269
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.LAS ADELFAS, S.A.",
        "DOMICILIO": "CTRA.SAN ADRIAN S\/N",
        "PROVINCIA": "LA RIOJA",
        "CP": 26500,
        "lat": 42.312302,
        "long": -1.953655
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PONTEBARXAS SL",
        "DOMICILIO": "PONTEBARXAS, 57",
        "PROVINCIA": "ORENSE",
        "CP": 32220,
        "lat": 42.137505,
        "long": -8.186664
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "COMBUST. BASTILIPO, S.A.",
        "DOMICILIO": "POL. IND. POLIVISO, PARC.2-3",
        "PROVINCIA": "SEVILLA",
        "CP": 41520,
        "lat": 37.40021,
        "long": -5.709101
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP ALMU\xd1A LUARCA",
        "DOMICILIO": "CTRA. ALMUNA-LUARCA S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33700,
        "lat": 43.535104,
        "long": -6.518613
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP VILLUIR",
        "DOMICILIO": "CN-634 KM.509,120",
        "PROVINCIA": "ASTURIAS",
        "CP": 33791,
        "lat": 43.53361,
        "long": -6.57033
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MOREDA ALLER S.C.",
        "DOMICILIO": "AVDA.CONSTITUCION, 91",
        "PROVINCIA": "ASTURIAS",
        "CP": 33670,
        "lat": 43.17183,
        "long": -5.74297
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP NAVA I",
        "DOMICILIO": "CN-634 KM-148",
        "PROVINCIA": "ASTURIAS",
        "CP": 33520,
        "lat": 43.373026,
        "long": -5.546679
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.LA PASIEGA",
        "DOMICILIO": "CN-623 KM.136",
        "PROVINCIA": "CANTABRIA",
        "CP": 39470,
        "lat": 43.359395,
        "long": -3.924524
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP NAVA II EL REMEDIO",
        "DOMICILIO": "CN-634, KM-379,7",
        "PROVINCIA": "ASTURIAS",
        "CP": 33529,
        "lat": 43.358921,
        "long": -5.49803
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CARBUEXPORT NALON",
        "DOMICILIO": "AVDA.DEL RIEGO N\xba5",
        "PROVINCIA": "ASTURIAS",
        "CP": 33138,
        "lat": 43.54095,
        "long": -6.1012
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. EL VIAL",
        "DOMICILIO": "AVDA. DE CUBA, 25",
        "PROVINCIA": "PALENCIA",
        "CP": 34003,
        "lat": 42.013794,
        "long": -4.521244
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES QUINTANA",
        "DOMICILIO": "AUTOVIA A620 KM54",
        "PROVINCIA": "PALENCIA",
        "CP": 34250,
        "lat": 42.07651,
        "long": -4.210489
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S. LA PALMERA",
        "DOMICILIO": "C\/PROSPERIDAD, 61",
        "PROVINCIA": "CANTABRIA",
        "CP": 39480,
        "lat": 43.404637,
        "long": -3.83577
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.MACANET DE LA SELVA",
        "DOMICILIO": "CC-251 KM.47",
        "PROVINCIA": "GIRONA",
        "CP": 17412,
        "lat": 41.780917,
        "long": 2.740999
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "XESTION OIL, S.L.",
        "DOMICILIO": "TOMAS PAREDES, 6 (GASOLINERAS)",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36208,
        "lat": 42.22173,
        "long": -8.75337
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. VEGAMOLINOS",
        "DOMICILIO": "AVDA. DE PORTUGAL, N\xba2",
        "PROVINCIA": "ORENSE",
        "CP": 32300,
        "lat": 42.421415,
        "long": -6.993972
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AREA DE SERVICIO A BARCA",
        "DOMICILIO": "CR PO-532 PKM.6,3 A REY GOSA",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36820,
        "lat": 42.407207,
        "long": -8.579014
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALERIAS GILDO",
        "DOMICILIO": "CTRA. N-620 KM 327,400",
        "PROVINCIA": "SALAMANCA",
        "CP": 37500,
        "lat": 40.581514,
        "long": -6.555984
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALERIAS GILDO",
        "DOMICILIO": "CTRA.SALAMANCA, 1",
        "PROVINCIA": "SALAMANCA",
        "CP": 37480,
        "lat": 40.6025,
        "long": -6.81875
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ESTACION DE SERVICIO S20",
        "DOMICILIO": "CALLE REPUENTE 29",
        "PROVINCIA": "CANTABRIA",
        "CP": 39011,
        "lat": 43.464728,
        "long": -3.833809
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES NTRA.SRA.DE LA SIERRA",
        "DOMICILIO": "AVDA. LUIS MONTOTO, 74",
        "PROVINCIA": "SEVILLA",
        "CP": 41018,
        "lat": 37.38736,
        "long": -5.96888
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MORON DLF",
        "DOMICILIO": "C/ DE LA TRILLA, N\xba1",
        "PROVINCIA": "SEVILLA",
        "CP": 41530,
        "lat": 37.12704,
        "long": -5.46027
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SAN ANTONIO",
        "DOMICILIO": "CTRA. A-392 P.K. 19,900",
        "PROVINCIA": "SEVILLA",
        "CP": 41510,
        "lat": 37.38119,
        "long": -5.73313
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.MONT ROIG PLAYA",
        "DOMICILIO": "CR N 340 KM 1139",
        "PROVINCIA": "TARRAGONA",
        "CP": 43300,
        "lat": 41.049419,
        "long": 0.999855
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S MONTROIG POLIGONO",
        "DOMICILIO": "C\/ KLAUS FISHER S\/N",
        "PROVINCIA": "TARRAGONA",
        "CP": 43300,
        "lat": 41.091495,
        "long": 0.965265
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.A.C.M., S.L.-ANDORRA",
        "DOMICILIO": "POL.IND.LA UMBRIA, N\xba33",
        "PROVINCIA": "TERUEL",
        "CP": 44500,
        "lat": 40.98228,
        "long": -0.44783
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP  E.S. ALBENTOSA",
        "DOMICILIO": "CN-234 KM 74",
        "PROVINCIA": "TERUEL",
        "CP": 44477,
        "lat": 40.11266,
        "long": -0.73883
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LARKIN ENERGIA, S.L.",
        "DOMICILIO": "CTRA. NACIONAL, 4 KM. 64,500",
        "PROVINCIA": "TOLEDO",
        "CP": 45300,
        "lat": 39.934127,
        "long": -3.489465
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GESCONTIGOLA",
        "DOMICILIO": "CN-IV, KM-55,200",
        "PROVINCIA": "TOLEDO",
        "CP": 45340,
        "lat": 39.97385,
        "long": -3.56724
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. FERLU S.L.",
        "DOMICILIO": "C\/ MADRIGAL KM 0",
        "PROVINCIA": "TOLEDO",
        "CP": 45560,
        "lat": 39.92665,
        "long": -5.18563
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "EE.SS. TORRIJOS S.L.",
        "DOMICILIO": "AVDA.TOLEDO, N\xba39",
        "PROVINCIA": "TOLEDO",
        "CP": 45500,
        "lat": 39.97869,
        "long": -4.26879
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CASTILLO DE BAYUELA",
        "DOMICILIO": "CRA.GARCIOTUN-CASTILLO DE BAYUELA KM.0,8",
        "PROVINCIA": "TOLEDO",
        "CP": 45641,
        "lat": 40.091659,
        "long": -4.675152
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S. EL ALAMO, S.L.",
        "DOMICILIO": "CAMINO PONTASAGO S\/N",
        "PROVINCIA": "TOLEDO",
        "CP": 45950,
        "lat": 40.23354,
        "long": -3.9865
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.SOMOVA, S.L.",
        "DOMICILIO": "C\/ CUENCA, 59",
        "PROVINCIA": "VALENCIA",
        "CP": 46970,
        "lat": 39.45683,
        "long": -0.46758
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CARLOS CLARI, S.L.",
        "DOMICILIO": "RONDA 9 DE OCTUBRE",
        "PROVINCIA": "VALENCIA",
        "CP": 46688,
        "lat": 39.19783,
        "long": -0.37444
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S.G. - LA REVA",
        "DOMICILIO": "POL.IND.REUS, SECTOR 12, PARCELA C",
        "PROVINCIA": "VALENCIA",
        "CP": 46190,
        "lat": 39.478639,
        "long": -0.569355
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "A.S.G. - BENEIXIDA",
        "DOMICILIO": "CTRA. N- 340 KM 855",
        "PROVINCIA": "VALENCIA",
        "CP": 46293,
        "lat": 39.05953,
        "long": -0.5445
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. V-30 SUR",
        "DOMICILIO": "CTRA. TRES CRUCES S\/N (V-30 SUR)",
        "PROVINCIA": "VALENCIA",
        "CP": 46017,
        "lat": 39.44117,
        "long": -0.40269
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "TRES CAMINOS SL-VALENCIA",
        "DOMICILIO": "C\/ MILAGROSA, 15",
        "PROVINCIA": "VALENCIA",
        "CP": 46009,
        "lat": 39.48491,
        "long": -0.37336
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AMERICANPETROL-ALAQUAS",
        "DOMICILIO": "C/ALADRES N\xba16 P.I. ELS MOLLONS",
        "PROVINCIA": "VALENCIA",
        "CP": 46970,
        "lat": 39.448643,
        "long": -0.473202
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PETROLAMO S.L - CST REC",
        "DOMICILIO": "CTRA. ALMASSORA CC-236 KM 9,390",
        "PROVINCIA": "CASTELLON",
        "CP": 12005,
        "lat": 39.968362,
        "long": -0.053144
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "OIL QUART",
        "DOMICILIO": "CARRE MARQUES DE TURIA, 9",
        "PROVINCIA": "VALENCIA",
        "CP": 46930,
        "lat": 39.47908,
        "long": -0.44401
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ZARAT\xc1N",
        "DOMICILIO": "C\/PARQUE OCIO EQUINOCIO, S\/N",
        "PROVINCIA": "VALLADOLID",
        "CP": 47610,
        "lat": 41.659669,
        "long": -4.774396
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E S  C I D Y",
        "DOMICILIO": "AVDA. DE SORIA N-122, KM 3,2",
        "PROVINCIA": "VALLADOLID",
        "CP": 47012,
        "lat": 41.61599,
        "long": -4.6912
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES VALLADOLID",
        "DOMICILIO": "AVDA. DE BURGOS, 40",
        "PROVINCIA": "VALLADOLID",
        "CP": 47009,
        "lat": 41.664709,
        "long": -4.73007
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES PISUERGA",
        "DOMICILIO": "RONDA INTERIOR SUR",
        "PROVINCIA": "VALLADOLID",
        "CP": 47008,
        "lat": 41.618325,
        "long": -4.720688
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S PUENTE DUERO",
        "DOMICILIO": " CTRA. VALLADOLID-RUEDA KM.12,400",
        "PROVINCIA": "VALLADOLID",
        "CP": 47152,
        "lat": 41.550266,
        "long": -4.795803
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. OLMEDO",
        "DOMICILIO": "CTRA. N601, KM 147,800",
        "PROVINCIA": "VALLADOLID",
        "CP": 47410,
        "lat": 41.281935,
        "long": -4.681807
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S MAYORGA",
        "DOMICILIO": "CRTA N-601 KM 269",
        "PROVINCIA": "VALLADOLID",
        "CP": 47680,
        "lat": 42.160785,
        "long": -5.267859
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ANDORRA LA VELLA",
        "DOMICILIO": "PRINCEP BENLLOCH, 82",
        "PROVINCIA": "ANDORRA",
        "CP": 55500,
        "lat": 42.505317,
        "long": 1.515234
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. VINALESA",
        "DOMICILIO": "CTRA.VINALESA-VALENCIA KM.2,8",
        "PROVINCIA": "VALENCIA",
        "CP": 46114,
        "lat": 39.53238,
        "long": -0.36677
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "EXPETROL",
        "DOMICILIO": "CTRA CALAMONTE-SEVILLA AP 038",
        "PROVINCIA": "BADAJOZ",
        "CP": 6810,
        "lat": 38.89743,
        "long": -6.38757
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.A-66 FUENTE DE CANTO",
        "DOMICILIO": "A66 KM.704 \/\/ FUENTE DE CANTOS",
        "PROVINCIA": "BADAJOZ",
        "CP": 6240,
        "lat": 38.25022,
        "long": -6.30101
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S VEGAS DE CORIA",
        "DOMICILIO": "CRTA EXTREMADURA 204, KM 62",
        "PROVINCIA": "CACERES",
        "CP": 10626,
        "lat": 40.38368,
        "long": -6.18737
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES SIERRA DE GATA SL",
        "DOMICILIO": "CTRA MORALEJA A CILLEROS KM 12.1",
        "PROVINCIA": "CACERES",
        "CP": 10895,
        "lat": 40.13013,
        "long": -6.78941
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LAVADO Y ENGRASE RAYCASL",
        "DOMICILIO": "AVENIDA AL-ANDALUS",
        "PROVINCIA": "CADIZ",
        "CP": 11540,
        "lat": 36.777,
        "long": -6.34545
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "25151007",
        "DOMICILIO": "CARRETERA NACIONAL 240 KM77",
        "PROVINCIA": "LLEIDA",
        "CP": 25141,
        "lat": 41.562918,
        "long": 0.800353
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.ARTAJONA",
        "DOMICILIO": "AVENIDA DIPUTACION 7",
        "PROVINCIA": "NAVARRA",
        "CP": 31140,
        "lat": 42.588626,
        "long": -1.75114
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.LALIN-BENDOIRO",
        "DOMICILIO": "CN-525, KM-296,2",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36510,
        "lat": 43.31355,
        "long": -8.168131
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES GALP AMPOSTA",
        "DOMICILIO": "CRTA. STA BARBARA KM, 1",
        "PROVINCIA": "TARRAGONA",
        "CP": 43870,
        "lat": 40.7082,
        "long": 0.56562
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VALDEPE\xd0AS",
        "DOMICILIO": "CN-IV KM.210,6",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13300,
        "lat": 38.89966,
        "long": -3.39135
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PTO.LAPICE DCH",
        "DOMICILIO": "CN-IV KM.140,5",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13650,
        "lat": 39.28776,
        "long": -3.45619
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PTO.LAPICE IZQ",
        "DOMICILIO": "CN-IV KM.140,5",
        "PROVINCIA": "CIUDAD REAL",
        "CP": 13650,
        "lat": 39.28807,
        "long": -3.4542
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP NAVAS DEL REY",
        "DOMICILIO": "POLIGONO INDUSTRIAL CA\xd0ADA DEL FRAILE",
        "PROVINCIA": "MADRID",
        "CP": 28695,
        "lat": 40.383159,
        "long": -4.240808
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP RIPOLLET",
        "DOMICILIO": "C\/TARRAGONA, 15-19",
        "PROVINCIA": "BARCELONA",
        "CP": 8291,
        "lat": 41.49493,
        "long": 2.15547
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.BARCELONA",
        "DOMICILIO": "PASEO ZONA FRANCA, 239",
        "PROVINCIA": "BARCELONA",
        "CP": 8038,
        "lat": 41.362994,
        "long": 2.136444
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BARC.-Z.FRANCA-PZ. CERDA",
        "DOMICILIO": "PS. ZONA FRANCA, 221",
        "PROVINCIA": "BARCELONA",
        "CP": 8038,
        "lat": 41.3334,
        "long": -2.12985
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GIJON",
        "DOMICILIO": "AVDA. DE LA ARGENTINA S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33212,
        "lat": 43.538223,
        "long": -5.703661
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S. TEMBLEQUE",
        "DOMICILIO": "CN-IV KM.99,5",
        "PROVINCIA": "TOLEDO",
        "CP": 45780,
        "lat": 39.63606,
        "long": -3.51767
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP COSTA",
        "DOMICILIO": "AVDA.PARALELO, 132",
        "PROVINCIA": "BARCELONA",
        "CP": 8015,
        "lat": 41.375223,
        "long": 2.160517
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -LEVANTE-",
        "DOMICILIO": "CTRA.COLLBLANCH, 14-16",
        "PROVINCIA": "BARCELONA",
        "CP": 8903,
        "lat": 41.375834,
        "long": 2.120788
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP OROPESA  -GP-",
        "DOMICILIO": "AVDA. PLANA, 3-5",
        "PROVINCIA": "CASTELLON",
        "CP": 12594,
        "lat": 40.09161,
        "long": 0.13175
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -LOS LEONES-",
        "DOMICILIO": "C\/ VALENCIA, 4",
        "PROVINCIA": "VALENCIA",
        "CP": 46100,
        "lat": 39.50013,
        "long": -0.40133
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LA GLEVA",
        "DOMICILIO": "CALLE DEL TER S\/N",
        "PROVINCIA": "BARCELONA",
        "CP": 8512,
        "lat": 42.004169,
        "long": 2.242351
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LA BISBAL",
        "DOMICILIO": "CC-255 KM-23,175",
        "PROVINCIA": "GIRONA",
        "CP": 17100,
        "lat": 41.97079,
        "long": 3.03086
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BORRASSA",
        "DOMICILIO": "CN-II KM.747",
        "PROVINCIA": "GIRONA",
        "CP": 17770,
        "lat": 42.215229,
        "long": 2.947804
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VILANOVA",
        "DOMICILIO": "CC-246 KM.43,350 AVDA. EDUARD TOLDRA, 67",
        "PROVINCIA": "BARCELONA",
        "CP": 8800,
        "lat": 41.228166,
        "long": 1.736022
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP VILLARROBLEDO",
        "DOMICILIO": "AVDA. REYES CATOLICOS N  108",
        "PROVINCIA": "ALBACETE",
        "CP": 2600,
        "lat": 39.272093,
        "long": -2.594041
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VERTIX",
        "DOMICILIO": "AVDA.11 DE SEPTIEMBRE",
        "PROVINCIA": "BARCELONA",
        "CP": 8820,
        "lat": 41.3141,
        "long": 2.06962
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VERTIX",
        "DOMICILIO": "AVDA.11 DE SEPTIEMBRE",
        "PROVINCIA": "BARCELONA",
        "CP": 8820,
        "lat": 41.3141,
        "long": 2.06962
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GRANJA DE ROCAMORA",
        "DOMICILIO": "AVDA. JUAN CARLOS I S\/N",
        "PROVINCIA": "ALICANTE",
        "CP": 3348,
        "lat": 38.1549,
        "long": -0.8898
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP E.S. LA NUCIA",
        "DOMICILIO": "AVDA. MARINA BAIXA 128",
        "PROVINCIA": "ALICANTE",
        "CP": 3530,
        "lat": 38.60302,
        "long": -0.12955
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP AGOST-AP7 DN1",
        "DOMICILIO": "AP-7, KM-14,600",
        "PROVINCIA": "ALICANTE",
        "CP": 3698,
        "lat": 38.40747,
        "long": -0.59897
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP AGOST-AP7 DS1",
        "DOMICILIO": "AP-7, KM-14,600",
        "PROVINCIA": "ALICANTE",
        "CP": 3698,
        "lat": 0.0,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP PRIMADO REIG-GP",
        "DOMICILIO": "AVDA.PRIMADO REIG, 10",
        "PROVINCIA": "VALENCIA",
        "CP": 46019,
        "lat": 39.4903,
        "long": -0.37202
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BORRIOL",
        "DOMICILIO": "CTRA. CV 16 KM 4,1",
        "PROVINCIA": "CASTELLON",
        "CP": 12190,
        "lat": 40.01427,
        "long": -0.12583
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GRANOLLERS",
        "DOMICILIO": "CBP-5002 KM.14,700",
        "PROVINCIA": "BARCELONA",
        "CP": 8400,
        "lat": 41.585961,
        "long": 2.284606
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP TERRASOL",
        "DOMICILIO": "CTRA.OLESA, 240-242",
        "PROVINCIA": "BARCELONA",
        "CP": 8224,
        "lat": 41.556116,
        "long": 1.991815
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP ZARAGOZA",
        "DOMICILIO": "VALLE DE BROTO, S\/N",
        "PROVINCIA": "ZARAGOZA",
        "CP": 50015,
        "lat": 41.66623,
        "long": -0.877007
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AP7-SAN ANTONIO DIR.TARR",
        "DOMICILIO": "AREA DE SERV SAN ANTONIO - AP7, PK 612,2",
        "PROVINCIA": "ALICANTE",
        "CP": 3750,
        "lat": 38.78998,
        "long": 0.06296
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AP7-SAN ANTONIO DIR.ALIC",
        "DOMICILIO": "AREA DE SERV SAN ANTONIO - AP7, PK 612,2",
        "PROVINCIA": "ALICANTE",
        "CP": 3750,
        "lat": 38.79217,
        "long": 0.0628
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP- E.S. ROJALES",
        "DOMICILIO": "AVD.DE LAS NACIONES,S\/N-U.CIUDAD QUESADA",
        "PROVINCIA": "ALICANTE",
        "CP": 3170,
        "lat": 38.06305,
        "long": -0.72877
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ELX A-7",
        "DOMICILIO": "AUTOVIA DEL MEDITERRANEO (A-7), KM-703",
        "PROVINCIA": "ALICANTE",
        "CP": 3202,
        "lat": 38.309815,
        "long": -0.6052
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - BCN MARAGALL",
        "DOMICILIO": "C\/ PASSEIG MARAGALL, RAMBLA DE VOLART, 2",
        "PROVINCIA": "BARCELONA",
        "CP": 8041,
        "lat": 41.415801,
        "long": 2.180166
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP FRANQUESAS",
        "DOMICILIO": "CC-251 KM.2,800",
        "PROVINCIA": "BARCELONA",
        "CP": 8520,
        "lat": 41.61984,
        "long": 2.31807
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES LAS FRANQUESAS",
        "DOMICILIO": "CTRA. C-251, PK 2,800",
        "PROVINCIA": "BARCELONA",
        "CP": 8520,
        "lat": 41.61984,
        "long": 2.31807
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP RETAMAR",
        "DOMICILIO": "CTRA. DE NIJAR, KM-14",
        "PROVINCIA": "ALMERIA",
        "CP": 4131,
        "lat": 36.85179,
        "long": -2.31149
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LOS PALACIOS",
        "DOMICILIO": "AP-4 20.100",
        "PROVINCIA": "SEVILLA",
        "CP": 41720,
        "lat": 37.168528,
        "long": -5.928649
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CTRA.ALMAZORA",
        "DOMICILIO": "CC-236 KM.9,3",
        "PROVINCIA": "CASTELLON",
        "CP": 12005,
        "lat": 39.977357,
        "long": -0.044687
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "EL EJIDO - CTRA. MALAGA",
        "DOMICILIO": "AVDA. DE MALAGA 492",
        "PROVINCIA": "ALMERIA",
        "CP": 4700,
        "lat": 36.774891,
        "long": -2.80225
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP UTRERA J.BOSCO",
        "DOMICILIO": "C\/ SAN JUAN BOSCO, 108",
        "PROVINCIA": "SEVILLA",
        "CP": 41710,
        "lat": 37.17556,
        "long": -5.77775
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -CASICAS-",
        "DOMICILIO": "CTRA. DEL PALMAR, 69",
        "PROVINCIA": "MURCIA",
        "CP": 30010,
        "lat": 37.97158,
        "long": -1.13669
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP OLIVA I -GP-",
        "DOMICILIO": "CN-332 KM.191",
        "PROVINCIA": "VALENCIA",
        "CP": 46780,
        "lat": 38.92291,
        "long": -0.12444
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SALVATIERRA",
        "DOMICILIO": "C\/ FUEROS, 2",
        "PROVINCIA": "ALAVA",
        "CP": 1200,
        "lat": 42.84896,
        "long": -2.3946
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -DENIA-1-",
        "DOMICILIO": "CTRA. DENIA - ONDARA S\/N",
        "PROVINCIA": "ALICANTE",
        "CP": 3700,
        "lat": 38.83891,
        "long": 0.0943
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP AVILA",
        "DOMICILIO": "AVDA. DE MADRID, 68",
        "PROVINCIA": "AVILA",
        "CP": 5001,
        "lat": 40.66234,
        "long": -4.69971
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -VILLAGARCIA-",
        "DOMICILIO": "CTRA. DE RUBIANES S\/N",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36619,
        "lat": 42.57597,
        "long": -8.73152
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP PALMERAS 1 -GP-",
        "DOMICILIO": "CN-III KM.322,250",
        "PROVINCIA": "VALENCIA",
        "CP": 46370,
        "lat": 39.47476,
        "long": -0.61233
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP PALMERAS 1 -GP",
        "DOMICILIO": "CN-III KM.322,250",
        "PROVINCIA": "VALENCIA",
        "CP": 46370,
        "lat": 39.47476,
        "long": -0.61233
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES CORNELLA-CRA DEL PRAT",
        "DOMICILIO": "CTRA.HOSPITALET ESQUINA CTRA.EL PRAT 200",
        "PROVINCIA": "BARCELONA",
        "CP": 8940,
        "lat": 41.35345,
        "long": 2.07656
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -YECLA-",
        "DOMICILIO": "CC-3314 KM.64,900",
        "PROVINCIA": "MURCIA",
        "CP": 30510,
        "lat": 38.61493,
        "long": -1.10313
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -EMILIO BARO-",
        "DOMICILIO": "C\/ EMILIO BARO N 69",
        "PROVINCIA": "VALENCIA",
        "CP": 46020,
        "lat": 39.48927,
        "long": -0.36038
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CALONGE",
        "DOMICILIO": "CTRA. C-253, 47,500",
        "PROVINCIA": "GIRONA",
        "CP": 17251,
        "lat": 41.836869,
        "long": 3.085982
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-VALLE DE HEBRON",
        "DOMICILIO": "P  VALLE DE HEBRON, 72-74",
        "PROVINCIA": "BARCELONA",
        "CP": 8023,
        "lat": 41.419654,
        "long": 2.140123
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP OLIVA II -GP-",
        "DOMICILIO": "CN-332, KM. 194",
        "PROVINCIA": "VALENCIA",
        "CP": 46780,
        "lat": 38.91311,
        "long": -0.11167
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -BOU II-",
        "DOMICILIO": "CN-340 KM.131",
        "PROVINCIA": "ALICANTE",
        "CP": 3800,
        "lat": 38.68338,
        "long": -0.4713
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP OLESA COLON",
        "DOMICILIO": "C\/COLON S\/N",
        "PROVINCIA": "BARCELONA",
        "CP": 8640,
        "lat": 41.54305,
        "long": 1.88644
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GUIPUZCOA",
        "DOMICILIO": "C\/ TIBIDABO, 54-86",
        "PROVINCIA": "BARCELONA",
        "CP": 8930,
        "lat": 41.427139,
        "long": 2.210439
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES.GALP N401-FUENLABRADA",
        "DOMICILIO": "CN-401, KM.18,4",
        "PROVINCIA": "MADRID",
        "CP": 28940,
        "lat": 40.265831,
        "long": -3.758569
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ZONA FRANCA",
        "DOMICILIO": "PASEO ZONA FRANCA, 75-81",
        "PROVINCIA": "BARCELONA",
        "CP": 8038,
        "lat": 41.355186,
        "long": 2.142058
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - VILADECANS",
        "DOMICILIO": "AVDA.PROGRESO, ESQ.CAN CALDERON",
        "PROVINCIA": "BARCELONA",
        "CP": 8840,
        "lat": 41.32129,
        "long": 2.03055
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - SANT POL MAR",
        "DOMICILIO": "SANT GALDERIC, 12-14",
        "PROVINCIA": "BARCELONA",
        "CP": 8395,
        "lat": 41.607928,
        "long": 2.604854
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP BARCELONA-TAJO",
        "DOMICILIO": "C\/TAJO, 28-34",
        "PROVINCIA": "BARCELONA",
        "CP": 8032,
        "lat": 41.429767,
        "long": 2.161329
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP TARRASA TEXTIL",
        "DOMICILIO": "AV. TEXTIL 34-40, P.I. STA.MARGARIDA",
        "PROVINCIA": "BARCELONA",
        "CP": 8223,
        "lat": 41.544583,
        "long": 2.025213
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MATARO-VIA SERGIA",
        "DOMICILIO": "VIA SERGIA, 100-CAMI DEL MIG 149",
        "PROVINCIA": "BARCELONA",
        "CP": 8303,
        "lat": 41.5326,
        "long": 2.42307
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CORNELLA-C.PROGRES",
        "DOMICILIO": "C\/PROGRESO ESQ.C\/ALBERT EINSTEIN POL.ALM",
        "PROVINCIA": "BARCELONA",
        "CP": 8940,
        "lat": 41.348062,
        "long": 2.081874
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BARCELONA - PUJADES",
        "DOMICILIO": "C\/ BAC DE RODA, ESQUINA PUJADES",
        "PROVINCIA": "BARCELONA",
        "CP": 8019,
        "lat": 41.40636,
        "long": 2.20612
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SANTA SUSANA",
        "DOMICILIO": "ROTONDA DE ENTRADA A SANTA SUSANA",
        "PROVINCIA": "BARCELONA",
        "CP": 8398,
        "lat": 41.6329,
        "long": 2.70421
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VILADECANS - AV. DE GAVA",
        "DOMICILIO": "AVDA. GAVA, ESQ. JOJEP TARRADELLAS",
        "PROVINCIA": "BARCELONA",
        "CP": 8840,
        "lat": 41.31205,
        "long": 2.01581
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "TORELLO - TER",
        "DOMICILIO": "C\/ DEL TER, 45",
        "PROVINCIA": "BARCELONA",
        "CP": 8570,
        "lat": 42.04858,
        "long": 2.253
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.VILANOVA",
        "DOMICILIO": "AVDA. CUBELLES, 64",
        "PROVINCIA": "BARCELONA",
        "CP": 8800,
        "lat": 41.21918,
        "long": 1.71631
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SABADELL - GRAN VIA",
        "DOMICILIO": "C\/ DOMENECH I MONTANER, 46",
        "PROVINCIA": "BARCELONA",
        "CP": 8205,
        "lat": 41.535072,
        "long": 2.104222
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "RIPOLLET - POLIG",
        "DOMICILIO": "CN-150 BARCELONA-SABADELL, 286-288",
        "PROVINCIA": "BARCELONA",
        "CP": 8291,
        "lat": 41.50137,
        "long": 2.13957
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VALLIRANA",
        "DOMICILIO": "CN-340, KM-1234,5",
        "PROVINCIA": "BARCELONA",
        "CP": 8759,
        "lat": 41.379556,
        "long": 1.919705
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -EL ALBIR-",
        "DOMICILIO": "CAP-535 KM.2",
        "PROVINCIA": "ALICANTE",
        "CP": 3580,
        "lat": 38.56772,
        "long": -0.08297
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SANT BOI-CASAB",
        "DOMICILIO": "CTRA SANTA CRUZ DE CALAFELL,41",
        "PROVINCIA": "BARCELONA",
        "CP": 8830,
        "lat": 41.33178,
        "long": 2.042164
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-CANAL OLIMPICO",
        "DOMICILIO": "AVENIDA CANAL OLIMPICO 21",
        "PROVINCIA": "BARCELONA",
        "CP": 8860,
        "lat": 41.281676,
        "long": 1.986345
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ESPLUGUES DE LLOBREGAT",
        "DOMICILIO": "AVDA. PAISSOS CATALANS, 2",
        "PROVINCIA": "BARCELONA",
        "CP": 8950,
        "lat": 41.377507,
        "long": 2.091627
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -BELLVITGE-",
        "DOMICILIO": "AUTOVIA DE CASTELLDEFELS, PK-2,7",
        "PROVINCIA": "BARCELONA",
        "CP": 8246,
        "lat": 41.34571,
        "long": 2.10946
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -ESTEPONA-",
        "DOMICILIO": "AUTOVIA COSTA DEL SOL KM.154,500",
        "PROVINCIA": "MALAGA",
        "CP": 29680,
        "lat": 36.43424,
        "long": -5.1607
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LOS BALBASES",
        "DOMICILIO": "AUTOViA A-62, PK 39,000 MD",
        "PROVINCIA": "BURGOS",
        "CP": 9119,
        "lat": 42.179179,
        "long": -4.059448
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP QUINCOCES",
        "DOMICILIO": "CC-550 KM.27",
        "PROVINCIA": "BURGOS",
        "CP": 9510,
        "lat": 42.978781,
        "long": -3.222661
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "QUINTANAR DE LA SIERRA",
        "DOMICILIO": "CTRA. SORIA, S\/N",
        "PROVINCIA": "BURGOS",
        "CP": 9670,
        "lat": 41.972645,
        "long": -3.040745
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-CTRA.A TRUJILLO",
        "DOMICILIO": "CR-N-521 KM. 38,130",
        "PROVINCIA": "CACERES",
        "CP": 10000,
        "lat": 39.464913,
        "long": -6.29669
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-CTRA.A MIAJADAS",
        "DOMICILIO": "CTRA. EX 206 KM. 3,900",
        "PROVINCIA": "CACERES",
        "CP": 10005,
        "lat": 39.442854,
        "long": -6.348578
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA MEJOSTILLA",
        "DOMICILIO": "C\/ EMILIO CARDENAL HERNANDEZ, 2",
        "PROVINCIA": "CACERES",
        "CP": 10004,
        "lat": 39.491104,
        "long": -6.368102
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP LAS CAPELLANIAS",
        "DOMICILIO": "C\/ HILANDERAS, 321 P.I.",
        "PROVINCIA": "CACERES",
        "CP": 10005,
        "lat": 39.484168,
        "long": -6.413076
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PERALEDA DE LA MATA",
        "DOMICILIO": "AUTOViA A-5 P. K. 171",
        "PROVINCIA": "CACERES",
        "CP": 10335,
        "lat": 39.891892,
        "long": -5.428512
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCALA HENARES A2 BRCLNA",
        "DOMICILIO": "CN-II KM.29",
        "PROVINCIA": "MADRID",
        "CP": 28802,
        "lat": 40.493209,
        "long": -3.386353
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -V. PERALES I-",
        "DOMICILIO": "CC-501 KM.27",
        "PROVINCIA": "MADRID",
        "CP": 28609,
        "lat": 40.379571,
        "long": -4.092643
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -V. PERALES II-",
        "DOMICILIO": "CC-501 KM.27",
        "PROVINCIA": "MADRID",
        "CP": 28609,
        "lat": 40.378704,
        "long": -4.09318
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCALA HENARES A2 MADRID",
        "DOMICILIO": "CN-II, KM-29",
        "PROVINCIA": "MADRID",
        "CP": 28802,
        "lat": 40.49335,
        "long": -3.387845
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. CASAS DE DON GOMEZ",
        "DOMICILIO": "CTRA. EX - 108, PK 95,6",
        "PROVINCIA": "CACERES",
        "CP": 10818,
        "lat": 40.02388,
        "long": -6.59596
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "N.S. GALP BOUZAS",
        "DOMICILIO": "C\/ TOMAS PAREDES, 6",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36208,
        "lat": 42.22169,
        "long": -8.75344
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "JEREZ - AREA SUR",
        "DOMICILIO": "ANTIGUA CARRETERA N-IV, KM:639.5",
        "PROVINCIA": "CADIZ",
        "CP": 11407,
        "lat": 36.68785,
        "long": -6.15462
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP JEREZ FRONTERA",
        "DOMICILIO": "A-381, KM-17",
        "PROVINCIA": "CADIZ",
        "CP": 11400,
        "lat": 36.524601,
        "long": -5.981766
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP COSLADA",
        "DOMICILIO": "AVDA. SN PABLO, 40 ESQ. ING. FDEZ.CASADO",
        "PROVINCIA": "MADRID",
        "CP": 28820,
        "lat": 40.430485,
        "long": -3.533864
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP ALGEZARES -GP-",
        "DOMICILIO": "CTRA.ALGEZARES-EL PALMAR KM.3",
        "PROVINCIA": "MURCIA",
        "CP": 30157,
        "lat": 37.94325,
        "long": -1.11858
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -BARBADANES-",
        "DOMICILIO": "CN-540 KM.0,7",
        "PROVINCIA": "ORENSE",
        "CP": 32005,
        "lat": 42.31844,
        "long": -7.87788
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ZARAGOZA DCHA",
        "DOMICILIO": "CN-II KM.306",
        "PROVINCIA": "ZARAGOZA",
        "CP": 50196,
        "lat": 41.61801,
        "long": -1.04684
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-CASSA DE SELVA-",
        "DOMICILIO": "CRTA. C-65, PK 16,120",
        "PROVINCIA": "GIRONA",
        "CP": 17244,
        "lat": 41.861264,
        "long": 2.885012
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BARBATE",
        "DOMICILIO": "CARRETERA VEJER-BARBATE, KM-95,7",
        "PROVINCIA": "CADIZ",
        "CP": 11160,
        "lat": 36.19956,
        "long": -5.92087
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CASTELLON",
        "DOMICILIO": "CTRA ALCORA CV 16 KM 17",
        "PROVINCIA": "CASTELLON",
        "CP": 12530,
        "lat": 40.00527,
        "long": -0.10844
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP BENIFAIO IZQ-GP",
        "DOMICILIO": "CC-3320 KM.36,350",
        "PROVINCIA": "VALENCIA",
        "CP": 46450,
        "lat": 39.28063,
        "long": -0.41502
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "NULES-DIR.VALENCIA",
        "DOMICILIO": "CTRA. C-226, PK 26,600 MI",
        "PROVINCIA": "CASTELLON",
        "CP": 12520,
        "lat": 39.656936,
        "long": -0.65038
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "NULES-DIR.CASTELLON",
        "DOMICILIO": "CTRA. C-226, PK 26,600 MD",
        "PROVINCIA": "CASTELLON",
        "CP": 12520,
        "lat": 39.84158,
        "long": -0.18077
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AP7-LA PLANA DIR.ALICANT",
        "DOMICILIO": "A.S LA PLANA - DIR ALICANTE AP7, PK 445",
        "PROVINCIA": "CASTELLON",
        "CP": 12530,
        "lat": 39.86608,
        "long": -0.1213
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "AP7 - LA PLANA DIR.TARRA",
        "DOMICILIO": "AREA DE SERVICIO LA PLANA, AP7, PK 445",
        "PROVINCIA": "CASTELLON",
        "CP": 12530,
        "lat": 39.8639,
        "long": -0.1239
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MEJORADA DEL C",
        "DOMICILIO": "CM-218 ESQ. C\/DUERO",
        "PROVINCIA": "MADRID",
        "CP": 28840,
        "lat": 40.386697,
        "long": -3.484468
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BETXI",
        "DOMICILIO": "CCS-223 KM.6,35",
        "PROVINCIA": "CASTELLON",
        "CP": 12549,
        "lat": 39.92319,
        "long": -0.18461
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP ALMASSORA",
        "DOMICILIO": "MANUEL VIVANCO, 10",
        "PROVINCIA": "CASTELLON",
        "CP": 12550,
        "lat": 39.94278,
        "long": -0.05885
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP QUART DE POBLET",
        "DOMICILIO": "C\/ MARQUES DEL TURIA, 9",
        "PROVINCIA": "VALENCIA",
        "CP": 46930,
        "lat": 39.47908,
        "long": -0.4443
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CARTAGENA CR. TENTEGORRA",
        "DOMICILIO": "CTRA.TENTEGORRA KM.1,1",
        "PROVINCIA": "MURCIA",
        "CP": 30205,
        "lat": 37.6148,
        "long": -1.00644
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP DEBA I",
        "DOMICILIO": "CN-634 KM.41",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20820,
        "lat": 43.294247,
        "long": -2.341037
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.LA GRELA",
        "DOMICILIO": "CTRA.BA\xd1OS DE ARTEIXO,16",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15008,
        "lat": 43.347394,
        "long": -8.426117
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MANILVA",
        "DOMICILIO": "CN-340 KM.141",
        "PROVINCIA": "MALAGA",
        "CP": 29691,
        "lat": 36.34183,
        "long": -5.23867
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-SEVILLA NUEVA 1",
        "DOMICILIO": "CM-600 KM.44,300",
        "PROVINCIA": "MADRID",
        "CP": 28609,
        "lat": 40.33855,
        "long": -4.019204
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-SEVILLA NUEVA 2",
        "DOMICILIO": "CM-600 KM.44,300",
        "PROVINCIA": "MADRID",
        "CP": 28609,
        "lat": 40.339029,
        "long": -4.018292
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -MONTSERRAT-",
        "DOMICILIO": "CN-II KM.573",
        "PROVINCIA": "BARCELONA",
        "CP": 8194,
        "lat": 41.56795,
        "long": 1.801758
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SOPELANA-PLENTZIA",
        "DOMICILIO": "CTRA. BI-634, PK 20,800 MD",
        "PROVINCIA": "VIZCAYA",
        "CP": 48600,
        "lat": 43.38218,
        "long": -2.988442
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. SOPELANA-BILBAO",
        "DOMICILIO": "CTRA. BI-634, PK 20,800 MI",
        "PROVINCIA": "VIZCAYA",
        "CP": 48600,
        "lat": 0.0,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP OQUILLAS",
        "DOMICILIO": "CN-I KM.176,6",
        "PROVINCIA": "BURGOS",
        "CP": 9350,
        "lat": 41.827019,
        "long": -3.707564
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VILLALBILLA",
        "DOMICILIO": "CM-300 KM.8,100",
        "PROVINCIA": "MADRID",
        "CP": 28810,
        "lat": 40.44649,
        "long": -3.361816
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LOURENZA",
        "DOMICILIO": "CN-634 KM.578,100",
        "PROVINCIA": "LUGO",
        "CP": 27760,
        "lat": 43.490045,
        "long": -7.28403
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CUENCA C.C",
        "DOMICILIO": "AVDA.DE LOS ALFARES S\/N",
        "PROVINCIA": "CUENCA",
        "CP": 16002,
        "lat": 40.076873,
        "long": -2.151368
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ALCOBENDAS I",
        "DOMICILIO": "CN-I KM.15,5",
        "PROVINCIA": "MADRID",
        "CP": 28100,
        "lat": 40.53236,
        "long": -3.64287
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CORDOBA",
        "DOMICILIO": "ASVDA. FUENTE DE LA SALUD, S\/N",
        "PROVINCIA": "CORDOBA",
        "CP": 14007,
        "lat": 37.90164,
        "long": -4.77236
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CALLE Y",
        "DOMICILIO": "\"MUELLE INFLAMABLES CALLE \"\"Y\"\"\"",
        "PROVINCIA": "BARCELONA",
        "CP": 8040,
        "lat": 41.327768,
        "long": 2.142715
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP TARACENA",
        "DOMICILIO": "AUTOViA N-II, KM 61",
        "PROVINCIA": "GUADALAJARA",
        "CP": 19193,
        "lat": 40.657804,
        "long": -3.119849
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ZARAGOZA IZDA",
        "DOMICILIO": "CN-II KM.306",
        "PROVINCIA": "ZARAGOZA",
        "CP": 50196,
        "lat": 41.61828,
        "long": -1.04245
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-CALERA Y CHOZAS",
        "DOMICILIO": "CN-V KM.137,200",
        "PROVINCIA": "TOLEDO",
        "CP": 45595,
        "lat": 39.917784,
        "long": -5.058571
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SARRACIN DCHA",
        "DOMICILIO": "CTRA. N I, KM 228,3",
        "PROVINCIA": "BURGOS",
        "CP": 9620,
        "lat": 42.24546,
        "long": -3.705955
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SARRACIN IZDA",
        "DOMICILIO": "CTRA. N I, KM 228,3",
        "PROVINCIA": "BURGOS",
        "CP": 9620,
        "lat": 42.245889,
        "long": -3.703251
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "CEDEIRA",
        "DOMICILIO": "LG LA MARAVILLA",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15350,
        "lat": 43.65348,
        "long": -8.04514
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. OZA DE LOS RIOS",
        "DOMICILIO": "CRTA. AC-840, PK 11,600",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15380,
        "lat": 43.225886,
        "long": -8.190761
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP EL FERROL",
        "DOMICILIO": "CTRA DE CATABOIS 762",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15405,
        "lat": 43.519371,
        "long": -8.220423
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.C.AMARILLA",
        "DOMICILIO": "C\/ANTONIO DE LA PENA LOPEZ, 5-7",
        "PROVINCIA": "SEVILLA",
        "CP": 41007,
        "lat": 37.387659,
        "long": -5.954458
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP NARON",
        "DOMICILIO": "AVDA. CEDEIRA AC-566 P.K. 1,5",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15578,
        "lat": 43.518724,
        "long": -8.187883
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MANANTIALES I",
        "DOMICILIO": "FRANCISCO ARITIO SN.",
        "PROVINCIA": "GUADALAJARA",
        "CP": 19004,
        "lat": 40.634897,
        "long": -3.190037
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VILLATORO",
        "DOMICILIO": "CTRA. SANTANDER KM. 2,5",
        "PROVINCIA": "BURGOS",
        "CP": 9006,
        "lat": 42.368184,
        "long": -3.69072
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CORU\xd0A",
        "DOMICILIO": "AV. ACEA DA MA, 25",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15670,
        "lat": 43.318873,
        "long": -8.374374
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PARAMO I",
        "DOMICILIO": "CN-120 KM.322,300",
        "PROVINCIA": "LEON",
        "CP": 24392,
        "lat": 42.524969,
        "long": -5.756707
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MONTSENY SUR",
        "DOMICILIO": "A-7 KM.117",
        "PROVINCIA": "BARCELONA",
        "CP": 8450,
        "lat": 41.647924,
        "long": 2.425538
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MONTSENY NORTE",
        "DOMICILIO": "AP-7 KM.117 (DIR. GERONA)",
        "PROVINCIA": "BARCELONA",
        "CP": 8350,
        "lat": 41.646809,
        "long": 2.425806
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PALAMOS",
        "DOMICILIO": "CN-225 KM.42,177",
        "PROVINCIA": "GIRONA",
        "CP": 17230,
        "lat": 41.86409,
        "long": 3.13653
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CUENCA RONDA",
        "DOMICILIO": "TRAVESIA RONDA OESTE,2",
        "PROVINCIA": "CUENCA",
        "CP": 16003,
        "lat": 40.054893,
        "long": -2.129816
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP FORTIA FIGUERES",
        "DOMICILIO": "CC-260 KM.33,056",
        "PROVINCIA": "GIRONA",
        "CP": 17469,
        "lat": 42.25926,
        "long": 3.04682
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP FORTIA ROSES",
        "DOMICILIO": "CC-260 KM.33,176",
        "PROVINCIA": "GIRONA",
        "CP": 17469,
        "lat": 42.25951,
        "long": 3.04835
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP ROSES",
        "DOMICILIO": "CRUCE CTRAS. GI-610 Y GI-614",
        "PROVINCIA": "GIRONA",
        "CP": 17480,
        "lat": 42.276624,
        "long": 3.158286
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP JONQUERA AS-24",
        "DOMICILIO": "CN-II KM.772,5",
        "PROVINCIA": "GIRONA",
        "CP": 17700,
        "lat": 42.397783,
        "long": 2.880607
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "JONQUERA - TRAMUNTANA",
        "DOMICILIO": "ENTRE CTRA. N-II Y CAMINO DE INLBOL",
        "PROVINCIA": "GIRONA",
        "CP": 17700,
        "lat": 42.410391,
        "long": 2.876291
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP JONQUERA-CENTRO",
        "DOMICILIO": "CTRA. N-II KM. 778",
        "PROVINCIA": "GIRONA",
        "CP": 17700,
        "lat": 42.417148,
        "long": 2.871824
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SANTA LLOGAIA D'ALGUEMA",
        "DOMICILIO": "AVDA. D'ALGUEMA, 2",
        "PROVINCIA": "GIRONA",
        "CP": 17771,
        "lat": 42.228976,
        "long": 2.955723
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "HUETOR-TAJAR A-92",
        "DOMICILIO": "A-92 KM.200",
        "PROVINCIA": "GRANADA",
        "CP": 18360,
        "lat": 37.17984,
        "long": -4.05924
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-PULIANAS",
        "DOMICILIO": "CTRA.VILCHEZ-ALMERIA, P.K-0,1",
        "PROVINCIA": "GRANADA",
        "CP": 18197,
        "lat": 37.2139,
        "long": -3.60966
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LEoN-URBANA",
        "DOMICILIO": "AVDA. ANTIBIoTICOS, S\/N",
        "PROVINCIA": "LEON",
        "CP": 24309,
        "lat": 42.572516,
        "long": -5.583104
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MAITETXU",
        "DOMICILIO": "CN-I, KM-453",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20100,
        "lat": 43.316179,
        "long": -1.905331
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MONDRAGON ARRASATE",
        "DOMICILIO": "SAN ANDRES AUZOA, 5",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20500,
        "lat": 43.047506,
        "long": -2.499826
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP LEZO I",
        "DOMICILIO": "CTRA.LEZO-IRUN KM.3,300",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20100,
        "lat": 43.327336,
        "long": -1.87084
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "HONDARRIBIA",
        "DOMICILIO": "GABARRARI, 22",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20280,
        "lat": 43.356358,
        "long": -1.794494
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "IRUN",
        "DOMICILIO": "AVENIDA LETXUMBORRO, 81",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20303,
        "lat": 43.332017,
        "long": -1.817482
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LASARTE",
        "DOMICILIO": "PASEO DEL HIPODROMO,79-BARRIO DE ZUBIETA",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20160,
        "lat": 43.254254,
        "long": -2.022787
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-ROSAL DE FRONT.",
        "DOMICILIO": "CN-433, KM-154,2",
        "PROVINCIA": "HUELVA",
        "CP": 21250,
        "lat": 37.96294,
        "long": -7.23914
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -HUELVA-GON-",
        "DOMICILIO": "AVDA.DE ITALIA, N 32",
        "PROVINCIA": "HUELVA",
        "CP": 21001,
        "lat": 37.25366,
        "long": -6.95205
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP- E.S. MEIS",
        "DOMICILIO": "VR-G41 KM.5,587",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36637,
        "lat": 42.498604,
        "long": -8.745045
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.MAZAGON",
        "DOMICILIO": "CH-442 KM.18",
        "PROVINCIA": "HUELVA",
        "CP": 21130,
        "lat": 37.13885,
        "long": -6.82292
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VIDRERAS IZQ",
        "DOMICILIO": "CTRA. C-35 KM 82,5",
        "PROVINCIA": "GIRONA",
        "CP": 17411,
        "lat": 41.785649,
        "long": 2.76173
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LOPORZANO",
        "DOMICILIO": "CTRA. N-240, PK 201,600",
        "PROVINCIA": "HUESCA",
        "CP": 22192,
        "lat": 42.14299,
        "long": -0.325164
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MONEGROS DIR BARCELONA",
        "DOMICILIO": "AP-2, PK 85.5",
        "PROVINCIA": "HUESCA",
        "CP": 22591,
        "lat": 41.518,
        "long": 0.04198
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MONEGROS DIR ZARAGOZA",
        "DOMICILIO": "AP-2, PK 85.5",
        "PROVINCIA": "HUESCA",
        "CP": 22591,
        "lat": 41.5181,
        "long": 0.0394
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VILLUIR-VALDES",
        "DOMICILIO": "CN-634 KM.509,120",
        "PROVINCIA": "ASTURIAS",
        "CP": 33791,
        "lat": 43.53361,
        "long": -6.57033
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP VILLAQUILAMBRE",
        "DOMICILIO": "CTRA. LE-311, KM. 3,500",
        "PROVINCIA": "LEON",
        "CP": 24193,
        "lat": 42.63323,
        "long": -5.55976
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. MANSILLA MAYOR",
        "DOMICILIO": "CTRA. N-601, KM. 312,400",
        "PROVINCIA": "LEON",
        "CP": 24217,
        "lat": 42.50146,
        "long": -5.41626
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP LLEIDA",
        "DOMICILIO": "CTRA 240 KM 100",
        "PROVINCIA": "LLEIDA",
        "CP": 25193,
        "lat": 41.645407,
        "long": 0.566262
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP BADAJOZ AV.PORTUGAL",
        "DOMICILIO": "AVDA. ADOLFO DiAZ AMBRONA, N  60",
        "PROVINCIA": "BADAJOZ",
        "CP": 6006,
        "lat": 38.88371,
        "long": -6.99068
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP ALMU\xd0A LUARCA",
        "DOMICILIO": "CTRA. ALMU\xd0A-LUARCA S/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33700,
        "lat": 43.535104,
        "long": -6.518613
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S. VIGO",
        "DOMICILIO": "ALCALDE LAVADORES ESQ. GANDARON, 32",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36214,
        "lat": 42.22311,
        "long": -8.69798
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP BADAJOZ.CTR.CACERES",
        "DOMICILIO": "C\/ NRA. SRA. DE BoTOA, N  110",
        "PROVINCIA": "BADAJOZ",
        "CP": 6007,
        "lat": 38.893416,
        "long": -6.970246
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-LUGO AV.DEPORT-",
        "DOMICILIO": "AVDA. DE LOS DEPORTES, N 12",
        "PROVINCIA": "LUGO",
        "CP": 27004,
        "lat": 43.006119,
        "long": -7.57238
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LUGO-CASTELO",
        "DOMICILIO": "CTRA. LU-530, P.K. 1,800",
        "PROVINCIA": "LUGO",
        "CP": 27190,
        "lat": 43.010621,
        "long": -7.537112
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES GALP GUITIRIZ MD",
        "DOMICILIO": "AUTOViA A-6 P.K. 538 M.D.",
        "PROVINCIA": "LUGO",
        "CP": 27300,
        "lat": 43.188512,
        "long": -7.92732
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES GALP GUITIRIZ MI",
        "DOMICILIO": "AUTOViA A-6 P.K. 538 M.I.",
        "PROVINCIA": "LUGO",
        "CP": 27300,
        "lat": 43.187405,
        "long": -7.929235
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MONFORTE LEMOS",
        "DOMICILIO": "CALLE BENITO VICETTO 77",
        "PROVINCIA": "LUGO",
        "CP": 27400,
        "lat": 42.51755,
        "long": -7.50519
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.EL VISO",
        "DOMICILIO": "AVDA. WASHINGTON, 68 (POL.IND. EL VISO)",
        "PROVINCIA": "MALAGA",
        "CP": 29010,
        "lat": 36.71366,
        "long": -4.4826
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES.GALP AJALVIR VICALVAR",
        "DOMICILIO": "AV. VICALVARO ESQ. POBLADURA DEL VALLE",
        "PROVINCIA": "MADRID",
        "CP": 28037,
        "lat": 40.42654,
        "long": -3.611745
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP SINESIO DELGADO",
        "DOMICILIO": "CL SINESIO DELGADO, N 110",
        "PROVINCIA": "MADRID",
        "CP": 28029,
        "lat": 40.473861,
        "long": -3.701497
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP AVDA ARCENTALES",
        "DOMICILIO": "AVDA. ARCENTALES, N 7",
        "PROVINCIA": "MADRID",
        "CP": 28037,
        "lat": 40.426524,
        "long": -3.626003
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - BRAVO MURILLO",
        "DOMICILIO": "C\/ BRAVO MURILLO, N 229",
        "PROVINCIA": "MADRID",
        "CP": 28020,
        "lat": 40.457266,
        "long": -3.701856
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MOSTOLES",
        "DOMICILIO": "C\/ SIMON HERNANDEZ, N 61",
        "PROVINCIA": "MADRID",
        "CP": 28092,
        "lat": 40.318197,
        "long": -3.852071
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP TORREJON VELASC",
        "DOMICILIO": "CR-404, KM28",
        "PROVINCIA": "MADRID",
        "CP": 28990,
        "lat": 40.188193,
        "long": -3.76433
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - BARAJAS",
        "DOMICILIO": "CAMINO DEL CUARTEL, N 9",
        "PROVINCIA": "MADRID",
        "CP": 28042,
        "lat": 40.467911,
        "long": -3.578668
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GETAFE",
        "DOMICILIO": "AVDA.ARCAS DEL AGUA, S\/N, SECTOR 3",
        "PROVINCIA": "MADRID",
        "CP": 28905,
        "lat": 40.29447,
        "long": -3.744702
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCALA HENARES",
        "DOMICILIO": "AVDA.VILLAMALEA,2",
        "PROVINCIA": "MADRID",
        "CP": 28805,
        "lat": 40.507649,
        "long": -3.352761
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "COBENA",
        "DOMICILIO": "C/ RIO JUCAR,2 URB.NUEVA COBE\xd0A",
        "PROVINCIA": "MADRID",
        "CP": 28863,
        "lat": 0.0,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP LAS ROZAS",
        "DOMICILIO": "CR CTRA.N-VI, KM. 21,900",
        "PROVINCIA": "MADRID",
        "CP": 28230,
        "lat": 40.51835,
        "long": -3.886735
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES.VALDEMORO-AVDA.MADRID",
        "DOMICILIO": "AVDA. DE MADRID, 6",
        "PROVINCIA": "MADRID",
        "CP": 28342,
        "lat": 40.206166,
        "long": -3.68428
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP CIEMPOZUELOS",
        "DOMICILIO": "M 404, P.K.39,8",
        "PROVINCIA": "MADRID",
        "CP": 28350,
        "lat": 40.165195,
        "long": -3.635911
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PINTO - EBOLI DIR. FUENL",
        "DOMICILIO": "CM-506 KM.17,5",
        "PROVINCIA": "MADRID",
        "CP": 28320,
        "lat": 40.255261,
        "long": -3.727241
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCOBENDAS - AV.MARQ",
        "DOMICILIO": "MARQUES DE VALDAVIA, 169",
        "PROVINCIA": "MADRID",
        "CP": 28100,
        "lat": 40.548448,
        "long": -3.661848
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S COLLADO VILLALBA",
        "DOMICILIO": "EL RINCON DE LAS HERAS, 3 BIS",
        "PROVINCIA": "MADRID",
        "CP": 28400,
        "lat": 40.636256,
        "long": -4.009516
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PINTO - EBOLI DIR. ARGAN",
        "DOMICILIO": "CM-506 KM.21,500",
        "PROVINCIA": "MADRID",
        "CP": 28320,
        "lat": 40.236262,
        "long": -3.705289
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MAJADAHONDA",
        "DOMICILIO": "CTRA.M-516 KM 0,5 P.I EL CARRALERO",
        "PROVINCIA": "MADRID",
        "CP": 28220,
        "lat": 40.455609,
        "long": -3.867466
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "COLMENAR VIEJO - LA MINA",
        "DOMICILIO": "RONDA CIRCUNVALACI\xcbN, 1",
        "PROVINCIA": "MADRID",
        "CP": 28770,
        "lat": 40.654719,
        "long": -3.760551
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "COSLADA - AV.JARAMA",
        "DOMICILIO": "AVDA.JARAMA, 19 ESQ. AVDA.SAN PABLO,36-B",
        "PROVINCIA": "MADRID",
        "CP": 28820,
        "lat": 40.432625,
        "long": -3.533628
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "FUENLABRADA",
        "DOMICILIO": "C\/LUIS SAUQUILLO C\/V C\/NARANJO DE BULNES",
        "PROVINCIA": "MADRID",
        "CP": 28943,
        "lat": 40.275022,
        "long": -3.805609
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PERALES",
        "DOMICILIO": "A-3 KM.41",
        "PROVINCIA": "MADRID",
        "CP": 28540,
        "lat": 40.223796,
        "long": -3.334622
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCALA HENARES - VIA COM",
        "DOMICILIO": "AVDA.DE LA COMPLUTENSE S\/N C\/V ESQ AVILA",
        "PROVINCIA": "MADRID",
        "CP": 28805,
        "lat": 40.493902,
        "long": -3.348609
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "TORREJON DE ARDOZ",
        "DOMICILIO": "AVDA. CONSTITUCIoN, 108",
        "PROVINCIA": "MADRID",
        "CP": 28850,
        "lat": 40.45844,
        "long": -3.466661
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP EL ESCORIAL",
        "DOMICILIO": "C\/ POZAS, N 140",
        "PROVINCIA": "MADRID",
        "CP": 28200,
        "lat": 40.60159,
        "long": -4.126426
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MADRID - ARGENTINA",
        "DOMICILIO": "AVDA. DE LOS POBLADOS, S\/N-ESQ.C\/ALBOX",
        "PROVINCIA": "MADRID",
        "CP": 28025,
        "lat": 40.373593,
        "long": -3.74326
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PARLA",
        "DOMICILIO": "C\/ BUENAVISTA, 2 -POL.IND.GARCIA RIVERA-",
        "PROVINCIA": "MADRID",
        "CP": 28980,
        "lat": 40.25146,
        "long": -3.764344
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.SANCHINARRO",
        "DOMICILIO": "AVDA.NICETO ALCALA ZAMORA,20",
        "PROVINCIA": "MADRID",
        "CP": 28050,
        "lat": 40.493782,
        "long": -3.647904
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.FUENLABRADA",
        "DOMICILIO": "AVDA HISPANIDAD,52(INTERS.M-506)",
        "PROVINCIA": "MADRID",
        "CP": 28945,
        "lat": 40.281682,
        "long": -3.770644
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - VALLECAS",
        "DOMICILIO": "AVDA.MAYORAZGO, S\/N",
        "PROVINCIA": "MADRID",
        "CP": 28051,
        "lat": 40.372261,
        "long": -3.635694
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-S.S.D LOS REYES",
        "DOMICILIO": "A-1, KM-26,2",
        "PROVINCIA": "MADRID",
        "CP": 28700,
        "lat": 40.605759,
        "long": -3.579054
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES VILLAREJO DE SALVANES",
        "DOMICILIO": "AVDA.JUAN CARLOS I REY DE ESPA\xd0A, 3",
        "PROVINCIA": "MADRID",
        "CP": 28590,
        "lat": 40.17258,
        "long": -3.291484
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-POZUELO-HIPERCO",
        "DOMICILIO": "TRAVESIA PENALARA, 1",
        "PROVINCIA": "MADRID",
        "CP": 28224,
        "lat": 40.4588,
        "long": -3.80103
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LEGANES-SAN JOSE DE VALD",
        "DOMICILIO": "C. DEL TRUENO",
        "PROVINCIA": "MADRID",
        "CP": 28918,
        "lat": 40.3466,
        "long": -3.7969
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PARACUELLOS DE JARAMA",
        "DOMICILIO": "CAMINO VIEJO DE COBENA, 34",
        "PROVINCIA": "MADRID",
        "CP": 28860,
        "lat": 40.52199,
        "long": -3.54544
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MADRID-VILLAVERDE TOBALI",
        "DOMICILIO": "CL. LA ACEBEDA, N   57",
        "PROVINCIA": "MADRID",
        "CP": 28021,
        "lat": 40.3314,
        "long": -3.7154
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. BOADILLA VENTURA",
        "DOMICILIO": "AVDA.DE LA CONDESA DE CHINCHON N 37",
        "PROVINCIA": "MADRID",
        "CP": 28660,
        "lat": 40.398805,
        "long": -3.891164
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.BOADILLA.DIR BRUNETE",
        "DOMICILIO": "CR. BOADILLA-BRUNETE KM. 1,80",
        "PROVINCIA": "MADRID",
        "CP": 28660,
        "lat": 40.41291,
        "long": -3.893768
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.BOADILLA.DIR BOADILL",
        "DOMICILIO": "CR. BOADILLA-BRUNETE KM. 1,80",
        "PROVINCIA": "MADRID",
        "CP": 28660,
        "lat": 40.412263,
        "long": -3.894176
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VALDEMORO - LOS OLIVOS",
        "DOMICILIO": "AVDA. DE ESPA\xd0A C/V AGUADO",
        "PROVINCIA": "MADRID",
        "CP": 28340,
        "lat": 40.185406,
        "long": -3.692822
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES GALP PUERTA DE MADRID",
        "DOMICILIO": "C\/ ADOLFO MARSILLACH CC LA GARENA",
        "PROVINCIA": "MADRID",
        "CP": 28802,
        "lat": 40.474971,
        "long": -3.393961
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S. EL LIMONAR",
        "DOMICILIO": "CN-340,KM-244(AUT.RONDA ESTE,S.LIMONAR)",
        "PROVINCIA": "MALAGA",
        "CP": 29016,
        "lat": 36.7397,
        "long": -4.39441
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "FUENGIROLA",
        "DOMICILIO": "CL. MALVARROSA, 1\xe1 BARRIO LOS PACOS",
        "PROVINCIA": "MALAGA",
        "CP": 29640,
        "lat": 36.56427,
        "long": -4.62107
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "RONDA",
        "DOMICILIO": "A-367, KM 5.2,",
        "PROVINCIA": "MALAGA",
        "CP": 29400,
        "lat": 36.78352,
        "long": -5.1154
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MALAGA - SANTA BARBARA",
        "DOMICILIO": "C\/ TUCIDIDES, PARC. 14-15. POLG.STA.BAR",
        "PROVINCIA": "MALAGA",
        "CP": 29004,
        "lat": 36.69164,
        "long": -4.46186
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "FUENGIROLA - CTRA. MIJAS",
        "DOMICILIO": "CMA-409, P.K.6.00",
        "PROVINCIA": "MALAGA",
        "CP": 29640,
        "lat": 36.55623,
        "long": -4.62707
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MARBELLA - RODEITO",
        "DOMICILIO": "CN-340 KM.173,500",
        "PROVINCIA": "MALAGA",
        "CP": 29660,
        "lat": 36.48686,
        "long": -4.96631
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BENALMADENA - CARVAJAL",
        "DOMICILIO": "PAR.K SEC.PLANEAMIENTO SP-7ZONA CARVAJAL",
        "PROVINCIA": "MALAGA",
        "CP": 29639,
        "lat": 36.57234,
        "long": -4.59004
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ANTEQUERA",
        "DOMICILIO": "FINCA CAMPITO.ROTONDA DL SR.VERONICA S\/N",
        "PROVINCIA": "MALAGA",
        "CP": 29200,
        "lat": 37.02721,
        "long": -4.57642
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BENALMADENA",
        "DOMICILIO": "CC-407, KM-2,700",
        "PROVINCIA": "MALAGA",
        "CP": 29630,
        "lat": 36.60047,
        "long": -4.56151
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MARBELLA",
        "DOMICILIO": "AVDA. RICARDO SORIANO, 51",
        "PROVINCIA": "MALAGA",
        "CP": 29600,
        "lat": 36.510146,
        "long": -4.896693
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP CARTAGENA II-GP",
        "DOMICILIO": "CN-332 KM.110",
        "PROVINCIA": "MURCIA",
        "CP": 30310,
        "lat": 37.60494,
        "long": -0.96797
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.MAZARRON-",
        "DOMICILIO": "AVDA.D LOS COVACHOS,URB.CAMPOSOL-CAPRABO",
        "PROVINCIA": "MURCIA",
        "CP": 30875,
        "lat": 37.67708,
        "long": -1.33994
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP NOAIN",
        "DOMICILIO": "POL IND. TALLUNTXE II, MANZANA 7",
        "PROVINCIA": "NAVARRA",
        "CP": 31110,
        "lat": 42.77443,
        "long": -1.63326
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-ES.ALBURQUERQUE",
        "DOMICILIO": "EX-110 KM.32",
        "PROVINCIA": "BADAJOZ",
        "CP": 6510,
        "lat": 39.2187,
        "long": -7.00726
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ZUMARRAGA",
        "DOMICILIO": "ELIZ KALE S\/N",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20700,
        "lat": 43.087051,
        "long": -2.312885
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BEASAIN",
        "DOMICILIO": "CGI-632 KM.2",
        "PROVINCIA": "GUIPUZCOA",
        "CP": 20200,
        "lat": 43.04588,
        "long": -2.234581
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GIRONES N",
        "DOMICILIO": "A-7 KM.70,5",
        "PROVINCIA": "GIRONA",
        "CP": 17457,
        "lat": 41.907134,
        "long": 2.773192
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP PORTA BARCELONA SUR",
        "DOMICILIO": "A-7 KM.165,5",
        "PROVINCIA": "BARCELONA",
        "CP": 8755,
        "lat": 41.46808,
        "long": 1.97779
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP JONQUERA NORTE",
        "DOMICILIO": "A-7 KM.7",
        "PROVINCIA": "GIRONA",
        "CP": 17700,
        "lat": 42.40552,
        "long": 2.87448
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GIRONES SUR",
        "DOMICILIO": "A-7 KM.70,5",
        "PROVINCIA": "GIRONA",
        "CP": 17457,
        "lat": 41.905701,
        "long": 2.771679
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ALSASUA IZDA",
        "DOMICILIO": "CN-I KM.400",
        "PROVINCIA": "NAVARRA",
        "CP": 31800,
        "lat": 42.91762,
        "long": -2.19514
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP E.S. ZIORDIA",
        "DOMICILIO": "A-I, CN-MADRID-IRUN, KM-392",
        "PROVINCIA": "NAVARRA",
        "CP": 31809,
        "lat": 42.86479,
        "long": -2.23586
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP MOREDA DE ALLER",
        "DOMICILIO": "AVDA.CONSTITUCION, 91",
        "PROVINCIA": "ASTURIAS",
        "CP": 33670,
        "lat": 43.17183,
        "long": -5.74297
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP EL MUSEL",
        "DOMICILIO": "CTRA. N-641 - POL.PUERTO EL MUSEL",
        "PROVINCIA": "ASTURIAS",
        "CP": 33212,
        "lat": 43.550528,
        "long": -5.691714
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SANTA MARTA",
        "DOMICILIO": "CN-634 KM-148",
        "PROVINCIA": "ASTURIAS",
        "CP": 33520,
        "lat": 43.373026,
        "long": -5.546679
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP EL REMEDIO",
        "DOMICILIO": "CN-634, KM-379,7",
        "PROVINCIA": "ASTURIAS",
        "CP": 33529,
        "lat": 43.358921,
        "long": -5.49803
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.CORVERA DE ASTURIAS",
        "DOMICILIO": "CRTA. AS17 PK 3,5",
        "PROVINCIA": "ASTURIAS",
        "CP": 33404,
        "lat": 43.535153,
        "long": -5.889606
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP MIRANDA DE EBRO",
        "DOMICILIO": "CALLE LOGRO\xd0O, 70",
        "PROVINCIA": "BURGOS",
        "CP": 9200,
        "lat": 42.685795,
        "long": -2.93269
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PERLORA - CARRE\xd0O",
        "DOMICILIO": "BARRIO ESPASA, S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33491,
        "lat": 43.578443,
        "long": -5.754609
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LLANES",
        "DOMICILIO": "CL. MANUEL DIAZ ALEGRIA, 8",
        "PROVINCIA": "ASTURIAS",
        "CP": 33500,
        "lat": 43.424557,
        "long": -4.76242
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ARRIONDAS",
        "DOMICILIO": "EL PORTAZGO, S\/N",
        "PROVINCIA": "ASTURIAS",
        "CP": 33540,
        "lat": 43.3885,
        "long": -5.18275
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP PUENTE DUERO",
        "DOMICILIO": "CC-610 KM.12,400",
        "PROVINCIA": "VALLADOLID",
        "CP": 47152,
        "lat": 41.550728,
        "long": -4.796906
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP SALAS",
        "DOMICILIO": "AVDA. DE GALICIA, 12",
        "PROVINCIA": "ASTURIAS",
        "CP": 33860,
        "lat": 43.408546,
        "long": -6.259055
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S QUINTANA DEL PUENTE",
        "DOMICILIO": "AUTOV. A-62, PK 56,500 MD",
        "PROVINCIA": "PALENCIA",
        "CP": 34250,
        "lat": 42.07651,
        "long": -4.210489
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PALENCIA-EL VIAL- E0743-",
        "DOMICILIO": "AV. DE CUBA, 25",
        "PROVINCIA": "PALENCIA",
        "CP": 34004,
        "lat": 42.01425,
        "long": -4.52093
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP -SILLEDA-",
        "DOMICILIO": "A.P.-53, P.K-28",
        "PROVINCIA": "PONTEVEDRA",
        "CP": 36543,
        "lat": 42.71638,
        "long": -8.30083
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP ALDEHUELA",
        "DOMICILIO": "CTRA.A-62 KM 275",
        "PROVINCIA": "SALAMANCA",
        "CP": 37460,
        "lat": 40.854183,
        "long": -6.051397
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SANTA MARTA DE TORMES",
        "DOMICILIO": "AVDA. DE LA SERNA, 14-16",
        "PROVINCIA": "SALAMANCA",
        "CP": 37900,
        "lat": 40.950398,
        "long": -5.641086
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SANTA MARTA DE TORMES CT",
        "DOMICILIO": "CTRA. CL-510, PK 2,000",
        "PROVINCIA": "SALAMANCA",
        "CP": 37900,
        "lat": 40.93,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP TORRELAVEGA",
        "DOMICILIO": "aREA COMERCIAL GANZO(FRENTE BURGER KING)",
        "PROVINCIA": "CANTABRIA",
        "CP": 39300,
        "lat": 43.35918,
        "long": -4.065515
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SANTANDER - AV.V.TRUEBA-",
        "DOMICILIO": "AVDA.VICENTE TRUEBA,S\/N. ESQ.CIRUELOS",
        "PROVINCIA": "CANTABRIA",
        "CP": 39011,
        "lat": 43.457139,
        "long": -3.856869
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VILLACASTIN I",
        "DOMICILIO": "CTRA. N-IV PK 88 M.D.",
        "PROVINCIA": "SEGOVIA",
        "CP": 40006,
        "lat": 40.797601,
        "long": -4.460794
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP VILLACASTIN II",
        "DOMICILIO": "CTRA. N-IV PK 88 M.I.",
        "PROVINCIA": "SEGOVIA",
        "CP": 40006,
        "lat": 40.797436,
        "long": -4.462975
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S PALAZUELOS DE ERESMA",
        "DOMICILIO": "C\/ ESPIGAS, 4",
        "PROVINCIA": "SEGOVIA",
        "CP": 40194,
        "lat": 40.921044,
        "long": -4.07495
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP EL ESPINAR",
        "DOMICILIO": "AVDA. ALTO DEL LEON, 11",
        "PROVINCIA": "SEGOVIA",
        "CP": 40410,
        "lat": 40.71337,
        "long": -4.18808
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. LA DEHESA AREVALO",
        "DOMICILIO": "A-VI, KM-124,10",
        "PROVINCIA": "SEGOVIA",
        "CP": 40466,
        "lat": 41.043714,
        "long": -4.699169
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S. SAN JUAN",
        "DOMICILIO": "CTRA. TOMARES S\/N",
        "PROVINCIA": "SEVILLA",
        "CP": 41920,
        "lat": 37.37261,
        "long": -6.03377
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-ES.AV.ANDALUCIA",
        "DOMICILIO": "AVDA. ANDALUCIA N 44",
        "PROVINCIA": "SEVILLA",
        "CP": 41006,
        "lat": 37.38651,
        "long": -5.947522
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MONTELLANO",
        "DOMICILIO": "CALLE VILLAMARTIN, S\/N",
        "PROVINCIA": "SEVILLA",
        "CP": 41770,
        "lat": 36.99479,
        "long": -5.57676
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCALA DE GUADAIRA BANSU",
        "DOMICILIO": "A-92, PK. 4,000 MARGEN IZDO.",
        "PROVINCIA": "SEVILLA",
        "CP": 41500,
        "lat": 37.37963,
        "long": -5.8957
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP E.S. BOLLULLOS",
        "DOMICILIO": "POLIGONO INDUSTRIAL P.I.B.O.PARC.295\/296",
        "PROVINCIA": "SEVILLA",
        "CP": 41110,
        "lat": 37.350396,
        "long": -6.138211
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ARCOS DE JALON",
        "DOMICILIO": "CN-II KM.167",
        "PROVINCIA": "SORIA",
        "CP": 42250,
        "lat": 41.217032,
        "long": -2.291293
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - TORREDEMBARRA",
        "DOMICILIO": "T-214,KM-0,696 ENLACE N-340",
        "PROVINCIA": "TARRAGONA",
        "CP": 43830,
        "lat": 41.152067,
        "long": 1.393418
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. REUS",
        "DOMICILIO": "C\/RACASENS I MERCADE, 91",
        "PROVINCIA": "TARRAGONA",
        "CP": 43206,
        "lat": 41.154783,
        "long": 1.085494
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ROQUETES",
        "DOMICILIO": "P.I. LA RAVALETA, PARCELA 1",
        "PROVINCIA": "TARRAGONA",
        "CP": 43520,
        "lat": 40.810554,
        "long": 0.509619
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "S.CARLES RAPITA-DIR VAL",
        "DOMICILIO": "CTRA. N340 KM 1071",
        "PROVINCIA": "TARRAGONA",
        "CP": 43540,
        "lat": 40.625871,
        "long": 0.577995
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "S.CARLES RAPITA-DIR.BAR",
        "DOMICILIO": "CTRA. NACIONAL 340 KM 1071",
        "PROVINCIA": "TARRAGONA",
        "CP": 43540,
        "lat": 40.625785,
        "long": 0.579239
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALT CAMP DIR BARCELONA",
        "DOMICILIO": "AP-2, PK 196",
        "PROVINCIA": "TARRAGONA",
        "CP": 43400,
        "lat": 41.2863,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALT CAMP DIR LLEIDA",
        "DOMICILIO": "AP-2, PK 196",
        "PROVINCIA": "TARRAGONA",
        "CP": 43400,
        "lat": 41.2879,
        "long": 1.412
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CARRANQUE",
        "DOMICILIO": "CTRA. GRI\xd0ON S/N L. 16 KM 27,81",
        "PROVINCIA": "TOLEDO",
        "CP": 45216,
        "lat": 40.1693,
        "long": -3.90093
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-E.S.ALFAFAR",
        "DOMICILIO": "AVDA.TORRENTE S\/N",
        "PROVINCIA": "VALENCIA",
        "CP": 46910,
        "lat": 39.41552,
        "long": -0.39805
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SAN ANTONIO DE BENAGEBER",
        "DOMICILIO": "POL. NUM. 4 PARCELA, 548",
        "PROVINCIA": "VALENCIA",
        "CP": 46184,
        "lat": 39.55525,
        "long": -0.486917
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES VALENCIA - ARCHIDUQUE",
        "DOMICILIO": "PEDRAPIQUERS, 9",
        "PROVINCIA": "VALENCIA",
        "CP": 46014,
        "lat": 39.45636,
        "long": -0.40541
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S VALENCIA SERRERIA",
        "DOMICILIO": "AVDA. SERRERIA, 14",
        "PROVINCIA": "VALENCIA",
        "CP": 46022,
        "lat": 39.46452,
        "long": -0.33566
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MISLATA - XIRIVELLLA",
        "DOMICILIO": "CV-403,NUEVO ACCESO A XIRIVELLA (C-3215)",
        "PROVINCIA": "VALENCIA",
        "CP": 46920,
        "lat": 39.46865,
        "long": -0.43328
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VALENCIA -GENERAL AVILES",
        "DOMICILIO": "AVDA.GRAL.AVILES,ESQ.AVDA. 9 DE OCTUBRE",
        "PROVINCIA": "VALENCIA",
        "CP": 46015,
        "lat": 39.4815,
        "long": -0.40622
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP GANDIA",
        "DOMICILIO": "C\/ TETUAN, N 4",
        "PROVINCIA": "VALENCIA",
        "CP": 46702,
        "lat": 38.960667,
        "long": -0.177556
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP ALFAFAR II-P.S-",
        "DOMICILIO": "C\/RABISANCHO,21.PI-B MANZ.2(CV-31,KM-10)",
        "PROVINCIA": "VALENCIA",
        "CP": 46910,
        "lat": 39.41333,
        "long": -0.37922
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LLIRIA - DIR. VALENCIA",
        "DOMICILIO": "CTRA. VALENCIA-ADEMUZ, PK 30,800  MI",
        "PROVINCIA": "VALENCIA",
        "CP": 46160,
        "lat": 39.656936,
        "long": -0.65038
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S LLIRIA - DIR.ADEMUZ",
        "DOMICILIO": "CTRA. VALENCIA-ADEMUZ, PK 30,800 MD",
        "PROVINCIA": "VALENCIA",
        "CP": 46160,
        "lat": 39.656936,
        "long": -0.65038
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP RIBARROJA",
        "DOMICILIO": "CL. SEQUIA DEL QUINT, 14",
        "PROVINCIA": "VALENCIA",
        "CP": 46190,
        "lat": 39.542488,
        "long": -0.555762
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - A7 TORRENT -D",
        "DOMICILIO": "A-7, PK 346,200 MD",
        "PROVINCIA": "VALENCIA",
        "CP": 46900,
        "lat": 39.40027,
        "long": -0.49141
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP - A7 TORRENT -I",
        "DOMICILIO": "A-7, KM-519,3",
        "PROVINCIA": "VALENCIA",
        "CP": 46900,
        "lat": 39.39972,
        "long": -0.49236
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP VILLARGORDO DV1",
        "DOMICILIO": "A-3 KM.255",
        "PROVINCIA": "VALENCIA",
        "CP": 46317,
        "lat": 39.52603,
        "long": -1.437183
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP VILLARGORDO DM2",
        "DOMICILIO": "A-3 KM-255",
        "PROVINCIA": "VALENCIA",
        "CP": 46317,
        "lat": 39.525981,
        "long": -1.437185
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP CHIVA.CHESTE",
        "DOMICILIO": "CTRA. CV-417 ENLACE A-3 CV-378",
        "PROVINCIA": "VALENCIA",
        "CP": 46380,
        "lat": 39.47179,
        "long": -0.64474
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP EL PUIG",
        "DOMICILIO": "AUTOV. A-7, PK 311 DIR. CASTELLoN",
        "PROVINCIA": "VALENCIA",
        "CP": 46540,
        "lat": 39.59075,
        "long": -0.3031
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP TAVERNES",
        "DOMICILIO": "C\/ DE LA COSTERA, 19",
        "PROVINCIA": "VALENCIA",
        "CP": 46760,
        "lat": 39.067179,
        "long": -0.274541
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S GALP TORRENT PICANYA",
        "DOMICILIO": "CTRA.TORRENTE - PICANYA, KM. 1.2",
        "PROVINCIA": "VALENCIA",
        "CP": 46900,
        "lat": 39.43679,
        "long": -0.44654
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP VALLADOLID",
        "DOMICILIO": "AUTOViA A-11, PK 3,200 CON VA-20",
        "PROVINCIA": "VALLADOLID",
        "CP": 47012,
        "lat": 41.61599,
        "long": -4.6912
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. VALLADOLID -3024-",
        "DOMICILIO": "AVDA. DE BURGOS, 40",
        "PROVINCIA": "VALLADOLID",
        "CP": 47009,
        "lat": 41.664913,
        "long": -4.730194
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ZARATAN -3044-",
        "DOMICILIO": "PARQUE DE OCIO EQUINOCIO",
        "PROVINCIA": "VALLADOLID",
        "CP": 47610,
        "lat": 41.65996,
        "long": -4.774332
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. PISUERGA -3065-",
        "DOMICILIO": "C\/RONDA INTERIOR SUR,S\/N (PINAR DE JALON",
        "PROVINCIA": "VALLADOLID",
        "CP": 47008,
        "lat": 41.618325,
        "long": -4.720688
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MEDINA CAMPO",
        "DOMICILIO": "A-6, KM-164,620",
        "PROVINCIA": "VALLADOLID",
        "CP": 47400,
        "lat": 41.35531,
        "long": -4.958739
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP-OLMEDO",
        "DOMICILIO": "CTRA. N-601, PK 147,800",
        "PROVINCIA": "VALLADOLID",
        "CP": 47410,
        "lat": 41.2819,
        "long": -4.6818
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MAYORGA",
        "DOMICILIO": "CRTA. N 601, KM 269",
        "PROVINCIA": "VALLADOLID",
        "CP": 47680,
        "lat": 42.160785,
        "long": -5.267859
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BARAKALDO",
        "DOMICILIO": "CTRA. N-634, PK 120",
        "PROVINCIA": "VIZCAYA",
        "CP": 48903,
        "lat": 41.413457,
        "long": 2.206128
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "S.S. ZAMUDIO",
        "DOMICILIO": "CTRA. BI-737, PK 4,400",
        "PROVINCIA": "VIZCAYA",
        "CP": 48170,
        "lat": 43.29329,
        "long": -2.896762
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BARAKALDO",
        "DOMICILIO": "CRTA. N-634, PK 120,000",
        "PROVINCIA": "VIZCAYA",
        "CP": 48903,
        "lat": 43.290701,
        "long": -3.009911
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BENAVENTE",
        "DOMICILIO": "AV. FEDERICO SILVA, 137",
        "PROVINCIA": "ZAMORA",
        "CP": 49600,
        "lat": 41.999808,
        "long": -5.664538
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ALCO. AV.FERNANDO ALONSO",
        "DOMICILIO": "AVDA. FERNANDO ALONSO, 7",
        "PROVINCIA": "MADRID",
        "CP": 28108,
        "lat": 40.536558,
        "long": -3.615894
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "BLANES - POLIGONO",
        "DOMICILIO": "AV. D'EUROPA, 47",
        "PROVINCIA": "GIRONA",
        "CP": 17300,
        "lat": 41.675869,
        "long": 2.71459
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "LLORET DE MAR",
        "DOMICILIO": "CTRA. BLANES, 149",
        "PROVINCIA": "GIRONA",
        "CP": 17310,
        "lat": 41.69806,
        "long": 2.82724
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MONT-ROIG-NACIONAL",
        "DOMICILIO": "CTRA. N-340, PK 1.139,000",
        "PROVINCIA": "TARRAGONA",
        "CP": 43300,
        "lat": 41.049419,
        "long": 0.999855
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "MURO DE ALCOY",
        "DOMICILIO": "AUTOVIA A7, PK. 432",
        "PROVINCIA": "ALICANTE",
        "CP": 3830,
        "lat": 38.795067,
        "long": 0.448453
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP MONTEQUINTO",
        "DOMICILIO": "AV SAN JOSE DE CALASANZ 7",
        "PROVINCIA": "SEVILLA",
        "CP": 41089,
        "lat": 37.34499,
        "long": -5.93421
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. GALP BOLLULLOS A49",
        "DOMICILIO": "CTRA. UMBRETE-BOLLULLOS",
        "PROVINCIA": "SEVILLA",
        "CP": 41110,
        "lat": 37.36251,
        "long": -6.14426
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "VILANOVA PARC",
        "DOMICILIO": "C\/CERAMICA",
        "PROVINCIA": "BARCELONA",
        "CP": 8800,
        "lat": 41.23963,
        "long": 1.729344
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES VILLENA",
        "DOMICILIO": "AV. ALICANTE 81",
        "PROVINCIA": "ALICANTE",
        "CP": 3400,
        "lat": 38.626845,
        "long": -0.853732
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES NAVALCARNERO",
        "DOMICILIO": "CL DEHESA DE MARI-MARTIN S\/N P.I ALPARRA",
        "PROVINCIA": "MADRID",
        "CP": 28600,
        "lat": 40.291364,
        "long": -3.99878
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES NAVALCARNERO",
        "DOMICILIO": "CL DEHESA DE MARI-MARTIN S\/N P.I ALPARRA",
        "PROVINCIA": "MADRID",
        "CP": 28600,
        "lat": 0.0,
        "long": 0.0
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "PUERTO REAL",
        "DOMICILIO": "AVD. ESTEBAN MEINADER",
        "PROVINCIA": "CADIZ",
        "CP": 11519,
        "lat": 36.523934,
        "long": -6.236558
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "SEVILLA - AVDA. MOLINI",
        "DOMICILIO": "AV. MOLINI, 3",
        "PROVINCIA": "SEVILLA",
        "CP": 41012,
        "lat": 37.3692,
        "long": -5.9886
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES SANTA MARIA GUADALUPE",
        "DOMICILIO": "CTRA.N-502 PK.216,5",
        "PROVINCIA": "BADAJOZ",
        "CP": 6680,
        "lat": 39.31422,
        "long": -5.10335
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALP CASAS DE HARO",
        "DOMICILIO": "CP CTRA. DE POZOAMARGO, 1",
        "PROVINCIA": "CUENCA",
        "CP": 16611,
        "lat": 39.325112,
        "long": -2.266123
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S.GALP VALDEOBISPO",
        "DOMICILIO": "CTRA.EX-370 KM.15",
        "PROVINCIA": "CACERES",
        "CP": 10672,
        "lat": 40.06131,
        "long": -6.26008
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES JEREZ",
        "DOMICILIO": "AVD. MEDINA SIDONIA N\xba 9",
        "PROVINCIA": "CADIZ",
        "CP": 11406,
        "lat": 36.677097,
        "long": -6.124056
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. ORDES",
        "DOMICILIO": "CTRA. N-550, PK 34,500",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15680,
        "lat": 43.093427,
        "long": -8.40332
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S. NUEVA MILLADOIRO",
        "DOMICILIO": "RUA HEDRAS, 13",
        "PROVINCIA": "LA CORU\xd1A",
        "CP": 15895,
        "lat": 42.84969,
        "long": -8.58252
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "ES LA BRENA",
        "DOMICILIO": "AVDA. VIRGEN DE LA BRE#A , S\/N",
        "PROVINCIA": "CACERES",
        "CP": 10370,
        "lat": 39.6417,
        "long": -5.6417
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "E.S CATUXO I",
        "DOMICILIO": "CRTA. NACIONAL 634 KM.548",
        "PROVINCIA": "ASTURIAS",
        "CP": 33749,
        "lat": 43.54238,
        "long": -6.98361
    },
    {
        "BANDERA": "GALP",
        "NOMBRE TPV": "GALPGEST ELCHE-A7 DIR.AL",
        "DOMICILIO": "AUTOV. A-70, PK 25,000 MI",
        "PROVINCIA": "ALICANTE",
        "CP": 3320,
        "lat": 38.3097,
        "long": -0.60504
    }
];
const $2a9f999bc54a0719$export$62565d9c96ca242 = {
    SHELL: {
        width: 40,
        height: 40
    },
    AVIA: {
        width: 40,
        height: 80
    },
    BP: {
        width: 50,
        height: 50
    },
    CAMPSA: {
        width: 40,
        height: 80
    },
    CEPSA: {
        width: 80,
        height: 40
    },
    DISA: {
        width: 40,
        height: 80
    },
    GALP: {
        width: 110,
        height: 50
    },
    MEROIL: {
        width: 40,
        height: 80
    },
    PCAN: {
        width: 40,
        height: 80
    },
    PETROCAT: {
        width: 40,
        height: 80
    },
    PETROMIRALLES: {
        width: 40,
        height: 80
    },
    PETRONOR: {
        width: 40,
        height: 80
    },
    Q8: {
        width: 40,
        height: 80
    },
    REPSOL: {
        width: 50,
        height: 50
    },
    TAMOIL: {
        width: 40,
        height: 80
    },
    VALCARCE: {
        width: 40,
        height: 80
    },
    LIBRE: {
        width: 40,
        height: 40
    }
};
const $2a9f999bc54a0719$export$d1d228f217d37317 = {
    SHELL: "https://cdn.icon-icons.com/icons2/2699/PNG/512/shell_logo_icon_168832.png",
    AVIA: "https://upload.wikimedia.org/wikipedia/commons/c/c0/AVIA_International_logo.svg",
    BP: "https://images-wixmp-ed30a86b8c4ca887773594c2.wixmp.com/i/4ad36332-03b9-4804-aad7-acc8455a1109/d48a7vb-f8f3ad03-d9a4-4302-a47a-7d05b4ed9d54.png",
    CAMPSA: "./imgs/campsa.png",
    CEPSA: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Cepsa_Logo.png",
    DISA: "https://www.talantia.net/wp-content/uploads/2018/03/disa.png",
    GALP: "https://galp.com/es/img/galp-logo.png",
    MEROIL: "http://poolestaciones.es/wp-content/themes/bootstrap-basic-child/img/logo.png",
    PCAN: "https://freepngimg.com/download/map/66931-map-google-icons-maps-computer-marker-maker.png",
    PETROCAT: "https://www.baricentro.es/wp-content/uploads/sites/8/Petrocat.png",
    PETROMIRALLES: "https://freepngimg.com/download/map/66931-map-google-icons-maps-computer-marker-maker.png",
    PETRONOR: "https://petronor.eus/wp-content/uploads/2015/05/FondoVer1.jpg",
    Q8: "https://upload.wikimedia.org/wikipedia/commons/5/5c/Q8_logo.png",
    REPSOL: "https://www.liderlogo.es/wp-content/uploads/2022/12/pasted-image-0-5-4.png",
    TAMOIL: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Tamoil.svg/1200px-Tamoil.svg.png",
    VALCARCE: "https://freepngimg.com/download/map/66931-map-google-icons-maps-computer-marker-maker.png",
    LIBRE: "https://freepngimg.com/download/map/66931-map-google-icons-maps-computer-marker-maker.png"
};


const $35da740d59af89ba$var$form = document.getElementById("formulario");
const $35da740d59af89ba$var$lista = document.getElementById("lista");
const $35da740d59af89ba$var$error = document.getElementById("error");
let $35da740d59af89ba$var$map;
let $35da740d59af89ba$var$markers = [];
async function $35da740d59af89ba$var$initMap() {
    $35da740d59af89ba$var$map = new google.maps.Map(document.getElementById("map"), {
        center: {
            lat: 40.4556127,
            lng: -3.7058092
        },
        zoom: 7,
        gestureHandling: "greedy"
    });
    if (!navigator.geolocation) {
        console.log("Error: Fall\xf3 el servicio de geolocalizaci\xf3n.");
        return;
    }
    navigator.geolocation.getCurrentPosition(async (position)=>{
        const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            z: 12
        };
        $35da740d59af89ba$var$map.setCenter(userLocation);
        $35da740d59af89ba$var$map.setZoom(13);
        const filteredPoints = $35da740d59af89ba$var$getFilteredPoints(userLocation.lat, userLocation.lng);
        $35da740d59af89ba$var$displayHtmlList(filteredPoints.slice(0, 4), $35da740d59af89ba$var$lista);
    });
    $35da740d59af89ba$var$displayPoints((0, $2a9f999bc54a0719$export$4051a07651545597));
}
function $35da740d59af89ba$var$getFilteredPoints(lat, lng) {
    function haversineDistance(lat1, lon1, lat2, lon2) {
        const R = 6371; // Earth's radius in kilometers
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c; // Distance in kilometers
    }
    const pointsWithDistances = (0, $2a9f999bc54a0719$export$4051a07651545597).map((point)=>({
            ...point,
            distance: haversineDistance(lat, lng, point.lat, point.long)
        }));
    return pointsWithDistances.sort((a, b)=>a.distance - b.distance).slice(0, 10);
}
function $35da740d59af89ba$var$getLocationFromText(input) {
    return new Promise((resolve, reject)=>{
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            address: input
        }, (results, status)=>{
            if (status === "OK" && results[0]) {
                const { lat: lat, lng: lng } = results[0].geometry.location;
                resolve({
                    lat: lat(),
                    lng: lng()
                });
            } else reject("Geocoding failed: " + status);
        });
    });
}
async function $35da740d59af89ba$var$submitForm(e) {
    e.preventDefault();
    $35da740d59af89ba$var$error.innerHTML = "";
    const formData = new FormData($35da740d59af89ba$var$form);
    const location = formData.get("location");
    if (!location) return;
    try {
        const coordinates = await $35da740d59af89ba$var$getLocationFromText(location);
        const filteredPoints = $35da740d59af89ba$var$getFilteredPoints(coordinates.lat, coordinates.lng);
        if (filteredPoints.length > 0) {
            $35da740d59af89ba$var$map.setCenter(coordinates);
            $35da740d59af89ba$var$map.setZoom(13);
            $35da740d59af89ba$var$displayHtmlList(filteredPoints.slice(0, 5), $35da740d59af89ba$var$lista);
        } else $35da740d59af89ba$var$error.innerHTML = `
        <div class="flex flex-row justify-center items-center gap-3">
          <h1 class="text-center font-semibold text-xl">
            No se encontraron resultados para esta ubicaci\xf3n
            <i class="bi bi-compass text-lg"></i>
          </h1>
        </div>
      `;
        $35da740d59af89ba$var$displayPoints((0, $2a9f999bc54a0719$export$4051a07651545597));
    } catch (err) {
        $35da740d59af89ba$var$error.innerHTML = `
      <div class="flex flex-row justify-center items-center gap-3">
        <h1 class="text-center font-semibold text-xl">
          No se pudo encontrar la ubicaci\xf3n
          <i class="bi bi-compass text-lg"></i>
        </h1>
      </div>
    `;
        console.error(err);
    }
}
function $35da740d59af89ba$var$displayHtmlList(points, domElement) {
    domElement.innerHTML = "";
    points.forEach((point)=>{
        domElement.innerHTML += `
                    <a href="https://www.google.com/maps/search/?api=1&query=${point.lat},${point.long}">
                  <div class=" text-black hover:scale-105 transition-all cursor-pointer border-2  ">
                          <div class="flex flex-row justify-start items-center gap-3 px-4 py-3">
                              <i class="bi bi-geo-alt text-2xl"></i>
                              <h1 class="font-bold text-xl ">
                                  ${point["NOMBRE TPV"]}</h1>
                          </div>
                          <div class="border border-b"></div>
                          <div class="px-4 py-5">
                              <div class="flex flex-row justify-start items-center gap-3">
  
                                  <i class="bi bi-signpost"></i>
                                  <p>${point.DOMICILIO}</p>
                              </div>
                              <div class="flex flex-row justify-start items-center gap-3">
                                  <i class="bi bi-map"></i>
                                  <p>${point.PROVINCIA}</p>
                              </div>
                              <div class="flex flex-row justify-start items-center gap-3">
                                  <i class="bi bi-mailbox-flag"></i>
                                  <p>${point.CP}</p>
                              </div>
  
                          </div>
                      </div>
              </a>
          `;
    });
}
function $35da740d59af89ba$var$displayPoints(points) {
    const infoWindow = new google.maps.InfoWindow();
    points.forEach((point)=>{
        const marker = new google.maps.Marker({
            position: {
                lat: point.lat,
                lng: point.long
            },
            map: $35da740d59af89ba$var$map,
            title: point.NOMBRE,
            icon: {
                url: (0, $2a9f999bc54a0719$export$d1d228f217d37317)[point.BANDERA],
                scaledSize: new google.maps.Size((0, $2a9f999bc54a0719$export$62565d9c96ca242)[point.BANDERA].width * 0.6, (0, $2a9f999bc54a0719$export$62565d9c96ca242)[point.BANDERA].height * 0.6),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(10, 20),
                labelOrigin: new google.maps.Point(10, 10)
            }
        });
        marker.addListener("click", ()=>{
            infoWindow.setContent(`<strong>${point["BANDERA"]} ${point["NOMBRE TPV"]}</strong><p>${point.DOMICILIO}</p>`);
            infoWindow.open($35da740d59af89ba$var$map, marker);
        });
        $35da740d59af89ba$var$markers.push(marker);
    });
}
document.addEventListener("DOMContentLoaded", async ()=>{
    await $35da740d59af89ba$var$initMap();
    $35da740d59af89ba$var$form.addEventListener("submit", $35da740d59af89ba$var$submitForm);
});


//# sourceMappingURL=gasolineras.mieurotaller.com.08cce330.js.map
